/* kdChartJS 1.0.0 @ 2022-07-26T03:01:51.546Z */
import d3 from '../libs/d3';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

var DIRECTION = 1;
var INIT_LEVEL = Infinity;
var VIEW_OFFSET = 1000;
var WHEEL_STEP = 0.2;
var WHEEL_MAX = 2;
var WHEEL_MIN = 0.5;
var BASE_CARD_SIZE = {
    w: 150,
    h: 60,
    xSpace: 36,
    ySpace: 36
};
var SVG_THEME;
(function (SVG_THEME) {
    SVG_THEME["background"] = "#fff";
})(SVG_THEME || (SVG_THEME = {}));
var FONT_HEIGHT_MAP = {
    12: 16,
    14: 19,
    16: 21
};
var SVG_FONT_FAMILY = "Roboto,'San Francisco','Helvetica Neue',Helvetica,Arial,'PingFang SC','Hiragina Sans GB','WenQuanYi Micro Hei','microsoft yahei ui','microsoft yahei',sans-serif";

var CHART_WIDTH_S12FN = {
    "0": 6.6875,
    "1": 4.625,
    "2": 6.6875,
    "3": 6.6875,
    "4": 6.890625,
    "5": 6.6875,
    "6": 6.6875,
    "7": 6.46875,
    "8": 6.6875,
    "9": 6.6875,
    "q": 7.265625,
    "w": 8.78125,
    "e": 6.546875,
    "r": 4.28125,
    "t": 3.859375,
    "y": 5.875,
    "u": 6.9375,
    "i": 2.671875,
    "o": 7.28125,
    "p": 7.265625,
    "a": 6.40625,
    "s": 5.046875,
    "d": 7.265625,
    "f": 3.578125,
    "g": 7.265625,
    "h": 6.9375,
    "j": 2.671875,
    "k": 5.765625,
    "l": 2.671875,
    "z": 6.015625,
    "x": 5.46875,
    "c": 5.765625,
    "v": 5.875,
    "b": 7.265625,
    "n": 6.9375,
    "m": 10.65625,
    "Q": 9.78125,
    "W": 11.609375,
    "E": 6.484375,
    "R": 7.203125,
    "T": 6.640625,
    "Y": 7,
    "U": 8.40625,
    "I": 2.953125,
    "O": 9.875,
    "P": 7.0625,
    "A": 8.15625,
    "S": 6.453125,
    "D": 8.734375,
    "F": 6.03125,
    "G": 8.65625,
    "H": 8.78125,
    "J": 4.203125,
    "K": 6.828125,
    "L": 5.9375,
    "Z": 7.390625,
    "X": 7.296875,
    "C": 8.0625,
    "V": 7.828125,
    "B": 7.0625,
    "N": 9.1875,
    "M": 10.796875,
    "-": 5.15625,
    "=": 8.421875,
    "[": 3.65625,
    " ": 3.5625,
    "]": 3.65625,
    ";": 2.890625,
    "'": 2.78125,
    ",": 2.890625,
    ".": 2.890625,
    "·": 2.890625,
    "/": 4.75,
    "!": 3.6875,
    "@": 12.234375,
    "#": 7.828125,
    "$": 6.6875,
    "%": 10.171875,
    "^": 8.421875,
    "&": 9.03125,
    "*": 5.265625,
    "(": 3.65625,
    ")": 3.65625,
    "_": 5.390625,
    "+": 8.421875,
    "{": 3.65625,
    "}": 3.65625,
    ":": 2.890625,
    "\"": 4.34375,
    "&lt;": 8.421875,
    "&gt;": 8.421875,
    "?": 5.578125,
    "~": 8.421875,
    "`": 3.21875
};
var CHART_WIDTH_S14FN = {
    "0": 7.796875,
    "1": 5.390625,
    "2": 7.796875,
    "3": 7.796875,
    "4": 8.03125,
    "5": 7.796875,
    "6": 7.796875,
    "7": 7.546875,
    "8": 7.796875,
    "9": 7.796875,
    "q": 8.484375,
    "w": 10.234375,
    "e": 7.640625,
    "r": 5,
    "t": 4.5,
    "y": 6.859375,
    "u": 8.09375,
    "i": 3.109375,
    "o": 8.484375,
    "p": 8.484375,
    "a": 7.484375,
    "s": 5.875,
    "d": 8.484375,
    "f": 4.171875,
    "g": 8.484375,
    "h": 8.09375,
    "j": 3.109375,
    "k": 6.71875,
    "l": 3.109375,
    "z": 7.015625,
    "x": 6.375,
    "c": 6.71875,
    "v": 6.859375,
    "b": 8.484375,
    "n": 8.09375,
    "m": 12.4375,
    "Q": 11.40625,
    "W": 13.546875,
    "E": 7.5625,
    "R": 8.40625,
    "T": 7.734375,
    "Y": 8.171875,
    "U": 9.796875,
    "I": 3.453125,
    "O": 11.515625,
    "P": 8.234375,
    "A": 9.515625,
    "S": 7.515625,
    "D": 10.1875,
    "F": 7.03125,
    "G": 10.109375,
    "H": 10.234375,
    "J": 4.90625,
    "K": 7.96875,
    "L": 6.9375,
    "Z": 8.625,
    "X": 8.515625,
    "C": 9.40625,
    "V": 9.140625,
    "B": 8.234375,
    "N": 10.71875,
    "M": 12.59375,
    "-": 6.015625,
    "=": 9.828125,
    "[": 4.265625,
    " ": 4.15625,
    "]": 4.265625,
    ";": 3.359375,
    "'": 3.234375,
    ",": 3.359375,
    ".": 3.359375,
    "·": 3.359375,
    "/": 5.546875,
    "!": 4.3125,
    "@": 14.28125,
    "#": 9.140625,
    "$": 7.796875,
    "%": 11.859375,
    "^": 9.828125,
    "&": 10.546875,
    "*": 6.140625,
    "(": 4.265625,
    ")": 4.265625,
    "_": 6.28125,
    "+": 9.828125,
    "{": 4.265625,
    "}": 4.265625,
    ":": 3.359375,
    "\"": 5.078125,
    "&lt;": 9.828125,
    "&gt;": 9.828125,
    "?": 6.515625,
    "~": 9.828125,
    "`": 3.765625
};
var CHART_WIDTH_S16FN = {
    "0": 8.90625,
    "1": 6.15625,
    "2": 8.90625,
    "3": 8.90625,
    "4": 9.171875,
    "5": 8.90625,
    "6": 8.90625,
    "7": 8.625,
    "8": 8.90625,
    "9": 8.90625,
    "q": 9.6875,
    "w": 11.703125,
    "e": 8.734375,
    "r": 5.703125,
    "t": 5.140625,
    "y": 7.828125,
    "u": 9.25,
    "i": 3.546875,
    "o": 9.703125,
    "p": 9.6875,
    "a": 8.546875,
    "s": 6.71875,
    "d": 9.6875,
    "f": 4.765625,
    "g": 9.6875,
    "h": 9.25,
    "j": 3.546875,
    "k": 7.671875,
    "l": 3.546875,
    "z": 8.015625,
    "x": 7.28125,
    "c": 7.671875,
    "v": 7.828125,
    "b": 9.6875,
    "n": 9.25,
    "m": 14.203125,
    "Q": 13.03125,
    "W": 15.46875,
    "E": 8.640625,
    "R": 9.59375,
    "T": 8.84375,
    "Y": 9.328125,
    "U": 11.203125,
    "I": 3.9375,
    "O": 13.15625,
    "P": 9.40625,
    "A": 10.875,
    "S": 8.59375,
    "D": 11.640625,
    "F": 8.03125,
    "G": 11.546875,
    "H": 11.703125,
    "J": 5.609375,
    "K": 9.109375,
    "L": 7.921875,
    "Z": 9.84375,
    "X": 9.734375,
    "C": 10.734375,
    "V": 10.4375,
    "B": 9.40625,
    "N": 12.25,
    "M": 14.390625,
    "-": 6.875,
    "=": 11.234375,
    "[": 4.875,
    " ": 4.734375,
    "]": 4.875,
    ";": 3.84375,
    "'": 3.703125,
    ",": 3.84375,
    ".": 3.84375,
    "·": 3.84375,
    "/": 6.328125,
    "!": 4.921875,
    "@": 16.3125,
    "#": 10.4375,
    "$": 8.90625,
    "%": 13.546875,
    "^": 11.234375,
    "&": 12.046875,
    "*": 7.015625,
    "(": 4.875,
    ")": 4.875,
    "_": 7.171875,
    "+": 11.234375,
    "{": 4.875,
    "}": 4.875,
    ":": 3.84375,
    "\"": 5.796875,
    "&lt;": 11.234375,
    "&gt;": 11.234375,
    "?": 7.4375,
    "~": 11.234375,
    "`": 4.296875
};
var CHART_WIDTH_S12F6 = {
    "0": 7.40625,
    "1": 7.40625,
    "2": 7.40625,
    "3": 7.40625,
    "4": 7.40625,
    "5": 7.40625,
    "6": 7.40625,
    "7": 7.40625,
    "8": 7.40625,
    "9": 7.40625,
    "q": 7.984375,
    "w": 10.21875,
    "e": 6.984375,
    "r": 5.09375,
    "t": 4.96875,
    "y": 6.890625,
    "u": 7.78125,
    "i": 3.5625,
    "o": 7.890625,
    "p": 8,
    "a": 6.9375,
    "s": 5.9375,
    "d": 7.984375,
    "f": 4.875,
    "g": 7.984375,
    "h": 7.75,
    "j": 3.625,
    "k": 7.15625,
    "l": 3.5625,
    "z": 6.171875,
    "x": 7.03125,
    "c": 6.203125,
    "v": 6.9375,
    "b": 8,
    "n": 7.78125,
    "m": 11.796875,
    "Q": 9.828125,
    "W": 12.921875,
    "E": 6.875,
    "R": 8.390625,
    "T": 7.515625,
    "Y": 7.78125,
    "U": 9.328125,
    "I": 4.03125,
    "O": 9.828125,
    "P": 7.890625,
    "A": 9.03125,
    "S": 7.21875,
    "D": 9.5,
    "F": 6.703125,
    "G": 9.1875,
    "H": 9.859375,
    "J": 5.65625,
    "K": 8.328125,
    "L": 6.5625,
    "Z": 7.8125,
    "X": 8.40625,
    "C": 8.09375,
    "V": 8.578125,
    "B": 8.203125,
    "N": 10.1875,
    "M": 12.34375,
    "-": 5.25,
    "=": 9.140625,
    "[": 4.6875,
    " ": 3.578125,
    "]": 4.6875,
    ";": 3.4375,
    "'": 3.703125,
    ",": 3.4375,
    ".": 3.4375,
    "·": 5.28125,
    "/": 5.671875,
    "!": 4.1875,
    "@": 12.359375,
    "#": 7.6875,
    "$": 7.40625,
    "%": 11.1875,
    "^": 9.140625,
    "&": 10.9375,
    "*": 5.859375,
    "(": 4.6875,
    ")": 4.6875,
    "_": 5.390625,
    "+": 9.140625,
    "{": 4.6875,
    "}": 4.6875,
    ":": 3.4375,
    "\"": 6.265625,
    "&lt;": 9.140625,
    "&gt;": 9.140625,
    "?": 5.703125,
    "~": 9.140625,
    "`": 4.015625
};
var CHART_WIDTH_S14F6 = {
    "0": 8.640625,
    "1": 8.640625,
    "2": 8.640625,
    "3": 8.640625,
    "4": 8.640625,
    "5": 8.640625,
    "6": 8.640625,
    "7": 8.640625,
    "8": 8.640625,
    "9": 8.640625,
    "q": 9.3125,
    "w": 11.921875,
    "e": 8.15625,
    "r": 5.9375,
    "t": 5.796875,
    "y": 8.046875,
    "u": 9.078125,
    "i": 4.15625,
    "o": 9.203125,
    "p": 9.328125,
    "a": 8.09375,
    "s": 6.921875,
    "d": 9.3125,
    "f": 5.6875,
    "g": 9.3125,
    "h": 9.046875,
    "j": 4.234375,
    "k": 8.359375,
    "l": 4.15625,
    "z": 7.203125,
    "x": 8.203125,
    "c": 7.234375,
    "v": 8.09375,
    "b": 9.328125,
    "n": 9.078125,
    "m": 13.75,
    "Q": 11.46875,
    "W": 15.078125,
    "E": 8.015625,
    "R": 9.78125,
    "T": 8.765625,
    "Y": 9.078125,
    "U": 10.875,
    "I": 4.703125,
    "O": 11.46875,
    "P": 9.203125,
    "A": 10.53125,
    "S": 8.421875,
    "D": 11.09375,
    "F": 7.828125,
    "G": 10.71875,
    "H": 11.5,
    "J": 6.59375,
    "K": 9.703125,
    "L": 7.65625,
    "Z": 9.109375,
    "X": 9.8125,
    "C": 9.4375,
    "V": 10.015625,
    "B": 9.578125,
    "N": 11.875,
    "M": 14.40625,
    "-": 6.125,
    "=": 10.671875,
    "[": 5.46875,
    " ": 4.171875,
    "]": 5.46875,
    ";": 4,
    "'": 4.328125,
    ",": 4,
    ".": 4,
    "·": 6.15625,
    "/": 6.625,
    "!": 4.890625,
    "@": 14.421875,
    "#": 8.96875,
    "$": 8.640625,
    "%": 13.046875,
    "^": 10.671875,
    "&": 12.765625,
    "*": 6.828125,
    "(": 5.46875,
    ")": 5.46875,
    "_": 6.28125,
    "+": 10.671875,
    "{": 5.46875,
    "}": 5.46875,
    ":": 4,
    "\"": 7.296875,
    "&lt;": 10.671875,
    "&gt;": 10.671875,
    "?": 6.640625,
    "~": 10.671875,
    "`": 4.671875
};
var CHART_WIDTH_S16F6 = {
    "0": 9.875,
    "1": 9.875,
    "2": 9.875,
    "3": 9.875,
    "4": 9.875,
    "5": 9.875,
    "6": 9.875,
    "7": 9.875,
    "8": 9.875,
    "9": 9.875,
    "q": 10.640625,
    "w": 13.625,
    "e": 9.3125,
    "r": 6.78125,
    "t": 6.625,
    "y": 9.1875,
    "u": 10.375,
    "i": 4.734375,
    "o": 10.515625,
    "p": 10.65625,
    "a": 9.25,
    "s": 7.90625,
    "d": 10.640625,
    "f": 6.484375,
    "g": 10.640625,
    "h": 10.328125,
    "j": 4.828125,
    "k": 9.546875,
    "l": 4.734375,
    "z": 8.21875,
    "x": 9.359375,
    "c": 8.265625,
    "v": 9.234375,
    "b": 10.65625,
    "n": 10.375,
    "m": 15.71875,
    "Q": 13.09375,
    "W": 17.21875,
    "E": 9.15625,
    "R": 11.171875,
    "T": 10.015625,
    "Y": 10.375,
    "U": 12.421875,
    "I": 5.375,
    "O": 13.09375,
    "P": 10.515625,
    "A": 12.03125,
    "S": 9.625,
    "D": 12.671875,
    "F": 8.9375,
    "G": 12.25,
    "H": 13.140625,
    "J": 7.53125,
    "K": 11.09375,
    "L": 8.75,
    "Z": 10.40625,
    "X": 11.203125,
    "C": 10.78125,
    "V": 11.4375,
    "B": 10.9375,
    "N": 13.578125,
    "M": 16.453125,
    "-": 6.984375,
    "=": 12.1875,
    "[": 6.234375,
    " ": 4.765625,
    "]": 6.234375,
    ";": 4.578125,
    "'": 4.9375,
    ",": 4.578125,
    ".": 4.578125,
    "·": 7.03125,
    "/": 7.5625,
    "!": 5.578125,
    "@": 16.484375,
    "#": 10.25,
    "$": 9.875,
    "%": 14.90625,
    "^": 12.1875,
    "&": 14.578125,
    "*": 7.796875,
    "(": 6.234375,
    ")": 6.234375,
    "_": 7.171875,
    "+": 12.1875,
    "{": 6.234375,
    "}": 6.234375,
    ":": 4.578125,
    "\"": 8.34375,
    "&lt;": 12.1875,
    "&gt;": 12.1875,
    "?": 7.59375,
    "~": 12.1875,
    "`": 5.34375
};

function getTextSvgDoms(textConfig) {
    var textParams = computedLinesNum(textConfig);
    var textDoms = [];
    var currTexts = textConfig.texts;
    for (var lineNO = 1; lineNO <= textParams.lineNums; lineNO++) {
        var res = getLineTextInfo(currTexts, textConfig, textParams);
        if (textConfig.wMode === "tb") {
            textDoms.push({
                text: res.txt,
                x: textConfig.bx + (lineNO - 1 / 2) * textConfig.fontSize,
                y: textConfig.by,
                len: res.txtWidth
            });
        }
        else {
            textDoms.push({
                text: res.txt,
                x: textConfig.bx,
                y: textConfig.by + lineNO * textConfig.fontSize,
                len: res.txtWidth
            });
        }
        currTexts = res.restText;
        if (currTexts.length == 0) {
            break;
        }
    }
    textDoms.map(function (txtItem) {
        var _a = __read(computedLoc(textConfig, txtItem.len, textDoms.length), 2), shiftX = _a[0], shiftY = _a[1];
        txtItem.x += shiftX;
        txtItem.y += shiftY;
    });
    var isEllipsis = currTexts.length > 0;
    if (isEllipsis && textDoms.length > 0) {
        var txt = textDoms[textDoms.length - 1].text;
        textDoms[textDoms.length - 1].text = txt.substr(0, txt.length - 1) + "…";
    }
    return { textDoms: textDoms, isEllipsis: isEllipsis };
}
function computedLoc(textConfig, len, realLines) {
    var shiftY = 0;
    var shiftX = 0;
    if (textConfig.wMode === "tb") {
        // 横向偏移
        shiftX = (textConfig.boxWidth - realLines * textConfig.fontSize) / 2;
        // 纵向偏移
        switch (textConfig.valign) {
            case "center":
                shiftY = (textConfig.boxHeight - len) / 2;
                break;
            case "bottom":
                shiftY = (textConfig.boxHeight - len);
                break;
        }
    }
    else {
        // 纵向偏移
        switch (textConfig.valign) {
            case "center":
                shiftY = (textConfig.boxHeight - realLines * textConfig.fontHeight) / 2;
                break;
            case "bottom":
                shiftY = (textConfig.boxHeight - realLines * textConfig.fontHeight);
                break;
        }
        // 横向偏移
        switch (textConfig.textAnchor) {
            case "middle":
                shiftX = (textConfig.boxWidth - len) / 2;
                break;
            case "end":
                shiftX = (textConfig.boxWidth - len);
                break;
        }
    }
    return [shiftX, shiftY];
}
function getLineTextInfo(currTexts, textConfig, textParams) {
    var txt = "";
    var step = 0;
    var txtWidth = 2;
    for (; step < currTexts.length; step++) {
        var charWidth = getChartWidth(currTexts[step], textConfig.fontSize, textConfig.fontWeight, textConfig.wMode);
        if (txtWidth + charWidth <= textParams.textLineWidth) {
            txt += currTexts[step];
            txtWidth += charWidth;
        }
        else {
            break;
        }
    }
    return {
        txt: txt,
        txtWidth: txtWidth,
        restText: currTexts.slice(step)
    };
}
function computedTextLine(textConfig, boxWidth) {
    var res = [];
    var currTexts = textConfig.texts;
    while (currTexts.length > 0) {
        var textRes = getLineTextInfo(currTexts, textConfig, {
            textLineWidth: boxWidth,
            lineNums: 0
        });
        currTexts = textRes.restText;
        res.push(textRes.txt);
    }
    return res;
}
function getChartWidth(chartCode, fontSize, fontWeight, wMode) {
    if (chartCode === void 0) { chartCode = ""; }
    if (fontSize === void 0) { fontSize = 14; }
    if (fontWeight === void 0) { fontWeight = 500; }
    var width = 0;
    if (chartCode.charCodeAt(0) > 255) {
        width = fontSize;
    }
    else {
        var cwType = "S" + fontSize + "F" + (fontWeight >= 600 ? "6" : "N");
        switch (cwType) {
            case "S12FN":
                width = CHART_WIDTH_S12FN[chartCode];
                break;
            case "S14FN":
                width = CHART_WIDTH_S14FN[chartCode];
                break;
            case "S16FN":
                width = CHART_WIDTH_S16FN[chartCode];
                break;
            case "S12F6":
                width = CHART_WIDTH_S12F6[chartCode];
                break;
            case "S14F6":
                width = CHART_WIDTH_S14F6[chartCode];
                break;
            case "S16F6":
                width = CHART_WIDTH_S16F6[chartCode];
                break;
        }
    }
    return width;
}
function getStrWidth(str, fontSize, fontWeight) {
    if (fontSize === void 0) { fontSize = 12; }
    if (fontWeight === void 0) { fontWeight = 100; }
    var len = 2;
    for (var i = 0; i < str.length; i++) {
        len += getChartWidth(str[i], fontSize, fontWeight);
    }
    return len;
}
function computedLinesNum(params) {
    var textLineWidth = 0;
    var lineNums = 0;
    if (params.wMode === "tb") {
        textLineWidth = params.boxHeight;
        lineNums = Math.floor(params.boxWidth / params.fontSize);
    }
    else {
        textLineWidth = params.boxWidth;
        lineNums = Math.floor(params.boxHeight / params.fontHeight);
    }
    return {
        textLineWidth: textLineWidth,
        lineNums: lineNums
    };
}

/* eslint-disable @typescript-eslint/ban-types */
// 基础工具类
function eachObj(data, cb) {
    each([data]);
    function each(list) {
        for (var i = 0; i < list.length; i++) {
            var item = list[i];
            cb(item);
            if (item.children && item.children.length > 0) {
                each(item.children);
            }
        }
    }
}
// 属性string||function
function resolveParams(param, defaultVal, data) {
    var res = defaultVal;
    if (typeof param === "function") {
        res = param(data);
    }
    else {
        res = param;
    }
    return res;
}
function delItem(list, item) {
    var index = -1;
    for (var i = 0; i < list.length; i++) {
        if (list[i].id === item.id) {
            index = i;
            break;
        }
    }
    list.splice(index, 1);
}
function pushItem(list, item) {
    // let index = -1
    // for (let i = 0; i < list.length; i++) {
    //     if (list[i].id === item.id) {
    //         index = i
    //         break;
    //     }
    // }
    // if (index === -1) {
    //     list.push(item)
    // }
    return list = __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(list), false), [item], false))));
}
function searchNodeByID(data, id, cb) {
    each([data]);
    function each(list) {
        for (var i = 0; i < list.length; i++) {
            if (list[i].id === id) {
                cb(list[i]);
                break;
            }
            list[i].children && each(list[i].children);
        }
    }
}
function exchangeItemSort(list, i, j, cbType) {
    var movei = list[i];
    switch (cbType) {
        case 1:
        case 3:
            list.splice(j, 0, movei);
            break;
        case 2:
        case 4:
            list.splice(j + 1, 0, movei);
            break;
    }
    if (i > j) {
        i += 1;
    }
    list.splice(i, 1);
}
function isIE() {
    return navigator.userAgent.toLowerCase().indexOf('trident') > -1 ? true : false;
}
function isFF() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ? true : false;
}

function computedCoordinate(treeData, baseCardSize) {
    if (!treeData)
        return null;
    var res = {};
    var tree = d3.tree().nodeSize([
        baseCardSize.w + baseCardSize.xSpace,
        baseCardSize.h + baseCardSize.ySpace,
    ]);
    var root = d3.hierarchy(treeData);
    tree(root);
    root.descendants().forEach(function (node) {
        res[node.data.id] = {
            x: node['x'],
            y: node['y'] + baseCardSize.h / 2 + 20,
            depth: node.depth
        };
    });
    return res;
}
function paintWrapper(wrapperId, wrapperSize) {
    var wrapper = d3.create("div")
        .attr("id", wrapperId)
        .attr("class", "svg_wrapper")
        .style("width", wrapperSize.w + "px")
        .style("height", wrapperSize.h + "px")
        .style("position", "absolute")
        .style("overflow", "hidden")
        .style("left", "50%")
        .style("top", "0")
        .style("transform", "translateX(-50%)");
    wrapper.html("<div class='null_data'><div class='img' ></div><p>暂无数据</p></div>");
    return wrapper;
}
function paintSvg(bgColor) {
    return d3.create("svg")
        .style("background", bgColor)
        .style("user-select", "none");
}
//矩形rect SVGDOM
function paintRect(node) {
    var rect = d3.create("svg:rect")
        .attr("class", "card-wrapper")
        .attr("width", node.cardSize.w)
        .attr("height", node.cardSize.h)
        .attr("rx", node.cardStyle.radius || 2)
        .attr("fill-opacity", 1)
        .attr("fill", node.cardStyle.background)
        .attr("stroke", node.cardStyle.border)
        .attr("stroke-dasharray", node.cardStyle.borderType)
        .attr("stroke-linecap", "round")
        .attr("stroke-opacity", 1)
        .attr("stroke-width", 1)
        .attr("shape-rendering", "auto");
    rect.node()["__data__"] = node;
    return rect;
}
function paintCardText(cardModel, node) {
    var textConfig = {
        texts: cardModel.text(node.data)[0] || "",
        fontSize: cardModel.fontSize,
        fontHeight: FONT_HEIGHT_MAP[cardModel.fontSize],
        fontWeight: cardModel.fontWeight || 500,
        color: resolveParams(cardModel.color, "#fff", node.data),
        wMode: cardModel.wMode || "lr",
        valign: cardModel.valign || "center",
        textAnchor: cardModel.textAnchor || "start",
        boxWidth: parseInt(cardModel.w + ''),
        boxHeight: parseInt(cardModel.h + ''),
        bx: cardModel.x,
        by: cardModel.y
    };
    var _a = getTextSvgDoms(textConfig), textDoms = _a.textDoms, isEllipsis = _a.isEllipsis;
    var textSvgDom = d3.create("svg:text")
        .attr("writing-mode", textConfig.wMode)
        .attr("fill", textConfig.color)
        .attr("xml:space", "preserve")
        .attr("text-anchor", "start")
        .attr("font-size", textConfig.fontSize)
        .attr("font-weight", textConfig.fontWeight)
        .attr("class", "cardto" + node.id);
    textDoms.map(function (textItem) {
        textSvgDom.append("svg:tspan")
            .text(textItem.text)
            .attr("x", textItem.x)
            .attr("y", textItem.y)
            .attr("font-family", SVG_FONT_FAMILY)
            .attr("word-spacing", 0)
            .attr("letter-spacing", 0)
            .attr("textLength", textItem.len);
    });
    return [textSvgDom, isEllipsis];
}
//切割图片
function getClipPath(clipId, params) {
    var defs = d3.create("svg:defs");
    var rectId = "imgRect" + clipId;
    var r = params.imgSize / 2;
    defs.append("circle")
        .attr("id", rectId)
        .attr("cx", params.x + r)
        .attr("cy", params.y + r)
        .attr("r", r)
        .attr("stroke", "#f00")
        .attr("stroke-width", 2);
    defs.append("clipPath")
        .attr("id", clipId)
        .append("use")
        .attr("xlink:href", "#" + rectId);
    return defs;
}
//图片img
function paintCardImg(cardModel, clipId, node, imgId, params) {
    return d3.create("svg:image")
        .attr("id", imgId)
        .attr("crossOrigin", "Anonymous")
        .attr("xlink:href", cardModel.url(node.data))
        .attr("width", params.imgSize)
        .attr("height", params.imgSize)
        .attr("x", params.x)
        .attr("y", params.y)
        .attr("clip-path", "url(#" + clipId + ")");
}
//矩形
function paintCardRect(cardModel, node) {
    var _a;
    var className = (_a = cardModel.class) !== null && _a !== void 0 ? _a : "";
    var cursor = className === "clickDom" ? "pointer" : "move";
    return d3.create("svg:rect")
        .attr("x", cardModel.x)
        .attr("y", cardModel.y)
        .attr("class", cardModel.class || "")
        .attr("rx", cardModel.rx)
        .attr("width", cardModel.w)
        .attr("height", cardModel.h)
        .attr("fill", resolveParams(cardModel.fill, "#fff", node.data))
        .attr("stroke", resolveParams(cardModel.stroke, "#fff", node.data))
        .attr("stroke-opacity", cardModel.strokeOpacity || 1)
        // .attr("shape-rendering", "crispEdges")
        .attr("cursor", cursor);
}
//圆形⚪
function paintCardCircle(cardModel, node) {
    return d3.create("svg:circle")
        .attr("r", cardModel.r)
        .attr("cx", cardModel.x)
        .attr("cy", cardModel.y)
        .attr("class", cardModel.class || "")
        .attr("fill", resolveParams(cardModel.fill, "#fff", node.data))
        .attr("stroke", resolveParams(cardModel.stroke, "#fff", node.data))
        .attr("stroke-opacity", cardModel.strokeOpacity || 1)
        .attr("shape-rendering", "crispEdges");
}
//线条
function paintCardPath(cardModel) {
    return d3.create("svg:path")
        .attr("class", "infoLine")
        .attr("d", "M".concat(cardModel.x, ",").concat(cardModel.y, " H").concat(cardModel.x + parseInt(cardModel.w + '')))
        .attr("fill-opacity", 0)
        .attr("stroke-width", 0.5)
        .attr("stroke", cardModel.stroke)
        .attr("shape-rendering", "crispEdges");
}
//字体图标
function paintCardIcon(cardModel, node) {
    return d3.create("svg:text")
        .html(cardModel.text(node.data) + '')
        .attr("class", "icon " + cardModel.class)
        .attr("font-size", cardModel.fontSize)
        .attr("fill", cardModel.fill)
        .attr("x", cardModel.x)
        .attr("y", cardModel.y + cardModel.fontSize);
}
//绘制虚影
function card2shadow(currParent, node, baseCardSize) {
    var loc = {
        x: node.x - node.cardSize.w / 2,
        y: node.y - baseCardSize.h / 2
    };
    var shadowDom = d3.create("svg:g")
        .attr("transform", "translate(" + loc.x + "," + loc.y + ")")
        .attr("class", "shadowGroup");
    shadowDom.append("svg:rect")
        .attr("width", node.cardSize.w)
        .attr("height", node.cardSize.h)
        .attr("rx", 2)
        .attr("stroke", "#1890ff")
        .attr("stroke-dasharray", "3 3 3")
        .attr("stroke-linecap", "round")
        .attr("stroke-opacity", 1)
        .attr("fill", "#eeeeee")
        .attr("fill-opacity", 1)
        .attr("stroke-width", 1)
        .attr("shape-rendering", "auto");
    currParent.appendChild(shadowDom.node());
}
//删除虚影
function delCard2shadow() {
    d3.selectAll(".shadowGroup").remove();
}
function createTipsTexts(textInfo, tipsWidth, tipsHeight, fontSize, fill, x, y) {
    if (tipsWidth === void 0) { tipsWidth = -1; }
    if (fontSize === void 0) { fontSize = 12; }
    if (fill === void 0) { fill = "#212121"; }
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    var strwidth = getStrWidth(textInfo, fontSize);
    var boxWidth = (tipsWidth < 0 ? strwidth : tipsWidth);
    // var lines = Math.ceil(strwidth / boxWidth);
    // var boxHeight = Math.max(lines * FONT_HEIGHT_MAP[fontSize] + 6, 10);
    var boxHeight = 16;
    var textConfig = {
        texts: textInfo || "",
        fontSize: fontSize,
        fontHeight: FONT_HEIGHT_MAP[fontSize],
        fontWeight: 500,
        color: fill,
        wMode: "lr",
        valign: "center",
        textAnchor: "start",
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        bx: 0,
        by: 0
    };
    var textList = computedTextLine(textConfig, boxWidth);
    boxHeight = Math.max(textList.length * FONT_HEIGHT_MAP[fontSize] + 6, 16);
    textConfig.boxHeight = boxHeight;
    var textDoms = getTextSvgDoms(textConfig).textDoms;
    var textSvgDom = d3.create("svg:text")
        .attr("x", x)
        .attr("y", y)
        .attr("writing-mode", textConfig.wMode)
        .attr("xml:space", "preserve")
        .attr("text-anchor", "start")
        .attr("font-size", textConfig.fontSize)
        .attr("font-weight", textConfig.fontWeight);
    textDoms.map(function (textItem,i) {
        textSvgDom.append("svg:tspan")
            .text(textItem.text)
            .attr("x", textItem.x + 5)
            // .attr("y", textItem.y)
            .attr("y", FONT_HEIGHT_MAP[fontSize] * (i + 1))
            .attr("fill", fill)
            .attr("font-family", SVG_FONT_FAMILY)
            .attr("word-spacing", 0)
            .attr("letter-spacing", 0)
            .attr("textLength", textItem.len);
    });
    return [
        d3.create("svg:rect")
            .attr("x", x)
            .attr("y", y)
            .attr("rx", 2)
            .attr("width", boxWidth + 10)
            .attr("height", boxHeight)
            .attr("fill", "#fff")
            .attr("stroke", "#ccc"),
        textSvgDom
    ];
}
//字体图标
function paintBtnIcon(icon, params) {
    if (isIE()) {
        return d3.create("svg:image")
            .attr("xlink:href", params.url)
            .attr("class", "icon " + params.className)
            .attr("crossOrigin", "Anonymous")
            .attr("width", params.fontSize)
            .attr("height", params.fontSize)
            .attr("x", params.x + 1)
            .attr("y", params.y - params.fontSize)
            .attr("cursor", "pointer");
    }
    else {
        return d3.create("svg:text")
            .html(icon)
            .attr("class", "icon " + params.className)
            .attr("font-size", params.fontSize)
            .attr("fill", params.fill)
            .attr("x", params.x)
            .attr("y", params.y)
            .attr("cursor", "pointer");
    }
}
// 简单按钮文字
function paintBtnText(params) {
    return d3.create("svg:text")
        .text(params.text)
        .attr("class", "icon manhead-icon " + params.class)
        .attr("fill", params.color)
        .attr("text-anchor", "start")
        .attr("font-size", params.fontSize)
        .attr("font-weight", params.fontWeight)
        .attr("x", params.x)
        .attr("y", params.y)
        .attr("font-family", SVG_FONT_FAMILY)
        .attr("word-spacing", 0)
        .attr("letter-spacing", 0)
        .attr("cursor", "pointer");
}
// 背景板 rect
function paintBtnRect(params) {
    var _a, _b, _c, _d;
    return d3.create("svg:rect")
        .attr("x", params.x)
        .attr("y", params.y)
        .attr("width", params.w)
        .attr("height", params.h)
        .attr("class", (_a = params.class) !== null && _a !== void 0 ? _a : "")
        .attr("rx", (_b = params.rx) !== null && _b !== void 0 ? _b : 1)
        .attr("fill", (_c = params.fill) !== null && _c !== void 0 ? _c : "#fff")
        .attr("stroke", (_d = params.stroke) !== null && _d !== void 0 ? _d : "#ccc")
        .attr("shape-rendering", "crispEdges");
}
function paintCircleMask(r, cx, cy, className) {
    return d3.create("svg:circle")
        .attr("class", className)
        .attr("r", r)
        .attr("cx", cx)
        .attr("cy", cy)
        .attr("fill", "#fff")
        .attr("stroke-opacity", 0)
        .attr("shape-rendering", "crispEdges");
}
function getIconLoc(direction, cardSize, fontSize) {
    var cx = cardSize.w / 2 - fontSize / 2; //按钮x坐标
    var cy = 0; //按钮y坐标
    switch (direction) {
        case 1:
            cy = cardSize.h + fontSize / 2 + 8;
            break;
        case 2:
            cy = cardSize.h / 2 + fontSize / 2;
            cx = cardSize.w + fontSize / 2;
            break;
        case 3:
            cy = -fontSize / 4;
            break;
        case 4:
            cy = cardSize.h / 2 + fontSize / 2;
            cx = -fontSize / 2;
            break;
    }
    return [cx, cy];
}

var ChartDataApp = /** @class */ (function () {
    function ChartDataApp(kdChartApp) {
        this.kdChartApp = kdChartApp;
        this.initChartData();
    }
    ChartDataApp.prototype.initChartData = function () {
        this.chartDataMap = {};
        this.chartData = this.initFormatData();
    };
    ChartDataApp.prototype.initFormatData = function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var _this = this;
        var locMap = this.getCardLocMap();
        var getNodes = this.nodeList;
        var getLinks = this.linkList;
        function foreach(list, parent) {
            if (parent === void 0) { parent = null; }
            var children = [];
            for (var i = 0; i < list.length; i++) {
                if (!list[i])
                    continue;
                var chartItem = __assign(__assign({ id: list[i].id, data: list[i], parent: parent }, locMap[list[i].id]), { getNodes: getNodes, getLinks: getLinks });
                chartItem.x0 = chartItem.x;
                chartItem.y0 = chartItem.y;
                if (list[i].children && list[i].children.length > 0) {
                    chartItem.children = foreach(list[i].children, chartItem);
                    chartItem._children = chartItem.children;
                }
                _this.kdChartApp.customChartItemAttr(chartItem, _this.kdChartApp.customParams);
                _this.chartDataMap[chartItem.id] = chartItem;
                children.push(chartItem);
            }
            return children;
        }
        return foreach([this.kdChartApp.treeDataApp.treeData], null)[0];
    };
    ChartDataApp.prototype.nodeList = function () {
        var res = [];
        eachObj(this, function (item) {
            res.push(item);
        });
        return res;
    };
    ChartDataApp.prototype.linkList = function () {
        var res = [];
        eachObj(this, function (item) {
            if (item.children && item.children.length > 0) {
                item.children.map(function (child) {
                    res.push({
                        source: item,
                        target: child
                    });
                });
            }
        });
        return res;
    };
    ChartDataApp.prototype.exchangeNode = function (pNode, i, j, changeType) {
        exchangeItemSort(pNode.children, i, j, changeType);
    };
    //重新计算坐标,并替换
    ChartDataApp.prototype.resetCardLoc = function () {
        var locMap = this.getCardLocMap();
        this.chartData.getNodes().forEach(function (node) {
            var newLoc = locMap[node.id];
            node.x = newLoc.x;
            node.x0 = node.x;
            node.y = newLoc.y;
            node.y0 = node.y;
            node.depth = newLoc.depth;
            node.height = newLoc.height;
        });
    };
    // 获取坐标
    ChartDataApp.prototype.getCardLocMap = function () {
        // 获取坐标
        return this.kdChartApp.computedLocMap(this.kdChartApp.treeDataApp.treeData, this.kdChartApp.baseCardSize, this.kdChartApp.chartWrapperSize, this.kdChartApp.direction, this.kdChartApp.customParams);
    };
    ChartDataApp.prototype.cardMenuEdit = function (node, newInfo) {
        var _this_1 = this;
        Object.keys(newInfo).map(function (key) {
            _this_1.chartDataMap[node.id].data[key] = newInfo[key];
        });
        this.kdChartApp.customChartItemAttr(this.chartDataMap[node.id], this.kdChartApp.customParams);
    };
    return ChartDataApp;
}());

var TipsCard = /** @class */ (function () {
    function TipsCard(parentViewApp) {
        this.parentViewApp = parentViewApp;
        this.initTipsGroup();
    }
    TipsCard.prototype.initTipsGroup = function () {
        this.showFlag = false;
        this.tipsGroup = this.parentViewApp.rootGroup
            .append("svg:g")
            .attr("style", "display:none")
            .attr("transform", "translate(0,0)");
    };
    TipsCard.prototype.showTipsCard = function (loc, text, showIcon, tipsW, tipsH) {
        var _this = this;
        if (showIcon === void 0) { showIcon = false; }
        if (tipsW === void 0) { tipsW = -1; }
        this.tipsGroup
            .attr("style", "")
            .attr("transform", "translate(".concat(loc.x, ",").concat(loc.y, ")"));
        if (!this.showFlag || this.text != text) {
            this.text = text;
            this.showFlag = true;
            this.tipsGroup._groups[0][0].innerHTML = "";
            createTipsTexts(text, tipsW).map(function (svgDom) {
                _this.tipsGroup.append(function () { return svgDom.node(); });
            });
        }
        showIcon && this.tipsGroup.append("svg:text")
            .html("&#xea48;")
            .attr("class", "icon kdfont")
            .attr("font-size", 12)
            .attr("fill", "#212121")
            .attr("x", 5)
            .attr("y", 20);
    };
    TipsCard.prototype.hideTipsGroup = function () {
        this.showFlag = false;
        this.tipsGroup
            .attr("style", "display:none")
            .attr("transform", "translate(0,0)");
        this.tipsGroup._groups[0][0].innerHTML = "";
    };
    return TipsCard;
}());

var CardMenu = /** @class */ (function () {
    function CardMenu(parentViewApp, menuModels) {
        this.parentViewApp = parentViewApp;
        this.menuModels = menuModels;
        this.currNode = null;
        this.showMenu = false;
        this.menuBtnMap = {};
        this.forbid = [];
    }
    CardMenu.prototype.initCardMenu = function () {
        var _this = this;
        console.log("initCardMenu");
        this.cardMenu = d3.create("svg:g")
            .attr("transform", "translate(0,0)")
            .attr("style", "display:none;")
            .on("mouseout", function (e) {
            var _a, _b;
            if (((_b = (_a = e.relatedTarget) === null || _a === void 0 ? void 0 : _a.nodeName) !== null && _b !== void 0 ? _b : "") === "svg") {
                _this.hiddenMenu();
            }
        });
        this.menuModels.map(function (menuModel) {
            var menuBtnItem;
            switch (menuModel.tag) {
                case "icon":
                    menuBtnItem = paintBtnIcon(menuModel.text, __assign(__assign({}, menuModel), { y: menuModel.y + menuModel.fontSize, className: "icon op-icon " + menuModel.class }));
                    _this.initMenuBtnItem(menuBtnItem, menuModel);
                    break;
                case "text":
                    menuBtnItem = paintBtnText(__assign(__assign({}, menuModel), { y: menuModel.y + menuModel.fontSize, className: "icon op-icon " + menuModel.class }));
                    _this.initMenuBtnItem(menuBtnItem, menuModel);
                    break;
                case "rect":
                    _this.cardMenu.append(function () { return paintBtnRect(menuModel).node(); });
                    break;
            }
        });
        this.parentViewApp.rootGroup.append(function () { return _this.cardMenu.node(); });
    };
    CardMenu.prototype.initMenuBtnItem = function (menuBtnItem, menuModel) {
        var _this = this;
        menuBtnItem.on("click", function () {
            if (_this.forbid.indexOf(menuModel.id) > -1)
                return;
            menuModel.click && (menuModel.click(_this.parentViewApp.kdChartApp, _this.currNode));
        });
        menuBtnItem.on("mousemove", function () {
            menuModel.tips && (_this.parentViewApp.tipsCard.showTipsCard({
                x: _this.currNode.x + _this.currNode.cardSize.w / 2 + menuModel.x + 24,
                y: _this.currNode.y - _this.currNode.cardSize.h / 2 + menuModel.y - menuModel.fontSize / 2
            }, menuModel.tips));
            if (_this.forbid.indexOf(menuModel.id) === -1) {
                menuModel.hover && menuBtnItem.attr("fill", menuModel.hover);
            }
        });
        menuBtnItem.on("mouseout", function () {
            _this.parentViewApp.tipsCard.hideTipsGroup();
            menuBtnItem.attr("fill", menuModel.fill);
        });
        this.cardMenu.append(function () { return menuBtnItem.node(); });
        if (menuModel.id) {
            this.menuBtnMap[menuModel.id] = menuBtnItem;
        }
    };
    CardMenu.prototype.showCardMenu = function (node) {
        var _this = this;
        var _a, _b;
        if (!this.cardMenu) {
            this.initCardMenu();
        }
        // 防止重复出发显示
        if (this.currNode && (node.id === ((_b = (_a = this.currNode) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "")) && this.showMenu)
            return;
        var _c = this.parentViewApp.kdChartApp.flagMenu(node), flag = _c.flag, forbid = _c.forbid;
        this.forbid = forbid;
        if (!flag)
            return;
        Object.keys(this.menuBtnMap).map(function (key) {
            // this.menuBtnMap[key].classed("gray", forbid.indexOf(key) >= 0)
            if (forbid.indexOf(key) >= 0) {
                _this.menuBtnMap[key].attr("fill", "#aaa");
            }
        });
        this.showMenu = true;
        this.currNode = node;
        this.cardMenu
            .attr("style", "")
            .attr("transform", "translate(".concat(node.x + node.cardSize.w / 2, ",").concat(node.y - this.parentViewApp.kdChartApp.baseCardSize.h / 2, ")"));
    };
    CardMenu.prototype.hiddenMenu = function () {
        this.showMenu = false;
        this.currNode = null;
        this.cardMenu && (this.cardMenu.attr("style", "display:none;"));
    };
    CardMenu.prototype.toogleCardMenu = function (node) {
        var _a, _b;
        this.showMenu = node.id === ((_b = (_a = this.currNode) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "");
        if (this.showMenu) {
            this.hiddenMenu();
        }
        else {
            this.showCardMenu(node);
        }
        this.showMenu = !this.showMenu;
    };
    return CardMenu;
}());

var SortCard = /** @class */ (function () {
    function SortCard(parentViewApp) {
        this.parentViewApp = parentViewApp;
        this.initSortCard();
    }
    SortCard.prototype.initSortCard = function () {
        this.sortPreRect = this.parentViewApp.rootGroup
            .append("svg:g")
            .attr("style", "display:none")
            .attr("transform", "translate(0,0)");
        this.sortPreRectInner = this.sortPreRect.append("svg:rect")
            .attr("width", this.parentViewApp.kdChartApp.baseCardSize.xSpace - 8)
            .attr("height", this.parentViewApp.kdChartApp.baseCardSize.h)
            .attr("rx", 2)
            .attr("stroke", "#1890ff")
            .attr("stroke-dasharray", "2 2 2")
            .attr("stroke-linecap", "round")
            .attr("stroke-opacity", 1)
            .attr("fill", "#e6f7ff")
            .attr("fill-opacity", 1)
            .attr("stroke-width", 1)
            .attr("shape-rendering", "auto");
    };
    SortCard.prototype.showSortCard = function (moveNode, targetNode, cbType) {
        var targeCardSize = targetNode.cardSize;
        var baseCardSize = this.parentViewApp.kdChartApp.baseCardSize;
        switch (cbType) {
            // 左
            case 1:
                this.transSortCard({
                    x: targetNode.x + 4 - targeCardSize.xSpace - targeCardSize.w / 2,
                    y: targetNode.y - baseCardSize.h / 2,
                    w: targeCardSize.xSpace - 8,
                    h: targeCardSize.h
                });
                break;
            // 右
            case 2:
                this.transSortCard({
                    x: targetNode.x + 4 + targeCardSize.w / 2,
                    y: targetNode.y - baseCardSize.h / 2,
                    w: targeCardSize.xSpace - 8,
                    h: targeCardSize.h
                });
                break;
            // 上
            case 3:
                this.transSortCard({
                    x: targetNode.x - targeCardSize.w / 2,
                    y: targetNode.y - baseCardSize.h / 2 - (targeCardSize.ySpace - 8) - 4,
                    w: targeCardSize.w,
                    h: targeCardSize.ySpace - 8
                });
                break;
            // 下
            case 4:
                this.transSortCard({
                    x: targetNode.x - targeCardSize.w / 2,
                    y: targetNode.y + baseCardSize.h / 2 + 4,
                    w: targeCardSize.w,
                    h: targeCardSize.ySpace - 8
                });
                break;
        }
    };
    SortCard.prototype.transSortCard = function (loc) {
        if (this.sortPreRect) {
            this.sortPreRect
                .attr("transform", "translate(" + loc.x + "," + loc.y + ")")
                .attr("style", "");
            this.sortPreRectInner
                .attr("height", loc.h)
                .attr("width", loc.w);
        }
    };
    SortCard.prototype.delSortCard = function () {
        if (this.sortPreRect) {
            this.sortPreRect.attr("style", "display:none");
            this.sortTargetNode = null;
        }
    };
    return SortCard;
}());

// 需要抽离
function getNodePaintLoc(currNode, baseCardSize, scale) {
    if (scale === void 0) { scale = 1; }
    return "translate( ".concat((currNode.x - currNode.cardSize.w / 2) * scale, ", ").concat((currNode.y - baseCardSize.h / 2) * scale, ")");
}
function getImgConfig(cardModel) {
    var boxW = parseInt(cardModel.w + '');
    var textAnchor = cardModel.textAnchor || "start"; //start middle end
    var valign = cardModel.valign || "center"; //top center bottom
    var imgSize = Math.min(boxW, cardModel.h);
    var x = cardModel.x;
    var y = cardModel.y;
    switch (textAnchor) {
        case "start":
            break;
        case "middle":
            x += (boxW - imgSize) / 2;
            break;
        case "end":
            x = boxW - imgSize;
            break;
    }
    switch (valign) {
        case "top":
            break;
        case "center":
            y += (cardModel.h - imgSize) / 2;
            break;
        case "bottom":
            y = cardModel.h - imgSize;
            break;
    }
    return { imgSize: imgSize, x: x, y: y };
}
function excludeClassName(e, classNameList) {
    var targetClassName = e.target.className ? e.target.className.baseVal : "";
    var flag = true;
    if (targetClassName !== "") {
        classNameList.map(function (className) {
            flag = flag && targetClassName.indexOf(className) < 0;
        });
    }
    return flag;
}
// 拖拽操作类型
// cbType 0:不作变更 1：排在目标左  2：排在目标右 3：排在目标上 4：排在目标下  5：挂到目标下 
function getMoveCBType(mouseLoc, moveNode, chartData, baseCardSize, isVerticalFunc, isSameListFunc, allowChildFunc) {
    var _a;
    var _b, _c;
    var cbType = 0;
    var target = null;
    var clist = (_c = (_b = moveNode.parent) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
    var moveNodeIndex = clist.indexOf(moveNode);
    for (var i = 0; i < clist.length; i++) {
        var node = clist[i];
        if (node.id === moveNode.id)
            continue;
        var offsetX = mouseLoc.x - node.x;
        var offsetY = mouseLoc.y - node.y;
        var nodeCardSize = node.cardSize;
        // 计算范围边界值
        var nodeWXS = nodeCardSize.w / 2 + nodeCardSize.xSpace;
        var nodeHYS = nodeCardSize.h / 2 + nodeCardSize.ySpace;
        // 是否纵向排序
        var isVertical = isVerticalFunc(moveNode);
        // 是否纵向同侧
        var isSameList = isSameListFunc(node, moveNode);
        // 纵向排序
        if (isVertical && Math.abs(offsetX) < nodeCardSize.w / 2) {
            // 往上
            if (!isSameList || moveNodeIndex > i) {
                if (offsetY < -nodeCardSize.h / 2 && offsetY > -nodeHYS) {
                    cbType = 3;
                    target = node;
                    break;
                }
            }
            // 往下
            if (!isSameList || moveNodeIndex < i) {
                if (offsetY > nodeCardSize.h / 2 && offsetY < nodeHYS) {
                    cbType = 4;
                    target = node;
                    break;
                }
            }
        }
        // 默认节点拖拽
        if (!isVertical && Math.abs(mouseLoc.y - node.y) < nodeCardSize.h / 2) {
            //往左
            if (i < moveNodeIndex) {
                if ((offsetX < -nodeCardSize.w / 2) && (offsetX > -nodeWXS)) {
                    cbType = 1;
                    target = node;
                    break;
                }
            }
            //往右
            if (i > moveNodeIndex) {
                if ((offsetX > nodeCardSize.w / 2) && (offsetX < nodeWXS)) {
                    cbType = 2;
                    target = node;
                    break;
                }
            }
        }
    }
    //不是排序，判断是否变更上下级
    if (cbType === 0) {
        _a = __read(isChangeParent(chartData, moveNode, baseCardSize, mouseLoc, allowChildFunc), 2), cbType = _a[0], target = _a[1];
    }
    return [cbType, target];
}
function isChangeParent(chartData, moveNode, baseCardSize, mouseLoc, allowChildFunc) {
    var cbType = 0;
    var target = null;
    each([chartData]);
    function each(list) {
        var _a, _b;
        for (var i = 0; i < list.length; i++) {
            var node = list[i];
            if (node.id !== moveNode.id) {
                var offsetX = mouseLoc.x - (node.x - node.cardSize.w / 2);
                var offsetY = mouseLoc.y - (node.y - baseCardSize.h / 2);
                //不能是父级
                //不能是单排、双排、侧节点
                if (node.id !== ((_b = (_a = moveNode.parent) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "") && allowChildFunc(node)) {
                    if (offsetX > 0 && offsetX < node.cardSize.w && offsetY > 0 && offsetY < node.cardSize.h) {
                        cbType = 5;
                        target = node;
                        break;
                    }
                }
                else {
                    if (offsetX > 0 && offsetX < node.cardSize.w && offsetY > 0 && offsetY < node.cardSize.h) {
                        cbType = 6;
                        break;
                    }
                }
                if (node.children && node.children.length > 0) {
                    each(node.children);
                }
            }
        }
    }
    return [cbType, target];
}
function getCircleMaskLoc(fontSize, x, y) {
    var width = fontSize - 3;
    return [width / 2, x + width / 2, y - width / 2 - 1];
}

var ChartCardApp = /** @class */ (function () {
    function ChartCardApp(parentViewApp) {
        this.parentViewApp = parentViewApp;
        this.duration = 500;
        this.selectedCards = [];
        this.toogleGroupMap = {};
        this.draging = false;
        this.sortCard = null;
        this.createCardGroup();
        this.initMenuGroup();
    }
    ChartCardApp.prototype.createCardGroup = function () {
        this.cardGroup = this.parentViewApp.rootGroup.append("g")
            .attr("cursor", "pointer")
            .attr("pointer-events", "visible");
    };
    ChartCardApp.prototype.delCardGroup = function () {
        console.log("delCardGroup", this.cardGroup);
        this.cardGroup.remove();
        this.selectedCards = [];
        this.toogleGroupMap = {};
    };
    ChartCardApp.prototype.initMenuGroup = function () {
        if (this.parentViewApp.menuModels) {
            this.cardMenuApp = new CardMenu(this.parentViewApp, this.parentViewApp.menuModels);
        }
        if (this.parentViewApp.hoverMenuModels) {
            this.cardHoverMenuApp = new CardMenu(this.parentViewApp, this.parentViewApp.hoverMenuModels);
        }
    };
    ChartCardApp.prototype.initPaint = function (rootNode, paintInfoFlag) {
        if (rootNode === void 0) { rootNode = this.parentViewApp.kdChartApp.chartDataApp.chartData; }
        if (paintInfoFlag === void 0) { paintInfoFlag = true; }
        var baseCardSize = this.parentViewApp.kdChartApp.baseCardSize;
        var editStatus = this.parentViewApp.editStatus;
        var transition = this.parentViewApp.rootGroup.transition().duration(this.duration);
        var nodeList = this.parentViewApp.kdChartApp.chartDataApp.chartData.getNodes().reverse();
        // 初始化每个卡片的group
        this.nodeGroup = this.cardGroup.selectAll("g").data(nodeList, function (d) {
            // console.log("卡片初始化 init group", d["id"]);
            return d["id"];
        });
        // 初始化位置都在顶点
        this.nodeEnter = this.nodeGroup.enter().append("g")
            .attr("class", function (d) { return "card-group cardto" + d.id + (editStatus ? " edit" : ""); })
            .attr("transform", function () {
            // console.log("初始化坐标 nodeEnter");
            return getNodePaintLoc(rootNode, baseCardSize);
        });
        // 卡片绑定事件
        this.bindCardEvent(this.nodeEnter);
        // 过渡到各自的位置
        this.setNodeUpdate();
        // 删除时过渡到顶点
        this.nodeGroup.exit().transition(transition).remove()
            .attr("transform", function () {
            // console.log("删除坐标");
            return getNodePaintLoc(rootNode, baseCardSize);
        })
            .attr("stroke-opacity", 0)
            .attr("fill-opacity", 0);
        // 绘制卡片信息
        paintInfoFlag && this.paintCard();
    };
    ChartCardApp.prototype.setNodeUpdate = function () {
        var transition = this.parentViewApp.rootGroup.transition().duration(this.duration);
        var baseCardSize = this.parentViewApp.kdChartApp.baseCardSize;
        var editStatus = this.parentViewApp.editStatus;
        // 过渡到各自的位置
        this.nodeUpdate = this.nodeGroup.merge(this.nodeEnter)
            .transition(transition)
            .attr("class", function (d) { return "card-group cardto" + d.id + (editStatus ? " edit" : ""); })
            .attr("transform", function (cardNode) {
            // console.log("正式坐标 nodeUpdate");
            return getNodePaintLoc(cardNode, baseCardSize);
        })
            .attr("fill-opacity", 1)
            .attr("stroke-opacity", 1);
    };
    ChartCardApp.prototype.resetPaintByLoc = function () {
        this.setNodeUpdate();
    };
    ChartCardApp.prototype.clearAllChartCard = function () {
        var _this = this;
        console.log("删除卡片信息");
        this.nodeUpdate.nodes().map(function (g) {
            if (g.childNodes.length > 0) {
                d3.select(g).selectAll("*").remove();
                delete _this.toogleGroupMap[g.__data__.id];
            }
        });
    };
    // 绑定卡片事件
    ChartCardApp.prototype.bindCardEvent = function (nodeEnter) {
        var _this = this;
        nodeEnter.call(d3.drag()
            .on("start", function (e, node) {
            if (!_this.parentViewApp.editStatus)
                return;
            _this.nodeDragStart(e, node);
        })
            .on("drag", function (e, node) {
            if (!_this.parentViewApp.editStatus)
                return;
            if (e.dx == 0 && e.dy == 0)
                return;
            if (!_this.draging) {
                _this.draging = true;
                _this.initNodeDraging(node);
            }
            _this.nodeDraging(e, node);
        })
            .on("end", function (e, node) {
            if (!_this.parentViewApp.editStatus)
                return;
            if (_this.draging) {
                _this.nodeDragend(e, node);
            }
            else {
                //  点击事件
                _this.clickCard(node);
            }
        })
            .filter(function (e) { return excludeClassName(e, ["op-icon"]); })).on("mousemove", function (e, node) {
            if (!excludeClassName(e, ["op-icon"]))
                return;
            _this.nodeMouseMove(e, node);
        }).on("mouseout", function (e, node) {
            if (!excludeClassName(e, ["op-icon"]))
                return;
            _this.nodeMouseMouseout(e, node);
        });
    };
    ChartCardApp.prototype.nodeDragStart = function (e, node) {
        // 
    };
    ChartCardApp.prototype.initNodeDraging = function (node) {
        //关闭卡片选择状态
        d3.selectAll("g.ghover").classed("ghover", false);
        //关闭卡片操作菜单
        this.closeCardMenu();
        // 将操作按钮提升展示层级
        var moveNodeDom = document.getElementsByClassName("cardto" + node["id"])[0];
        var moveNodeParent = moveNodeDom.parentNode;
        moveNodeParent.removeChild(moveNodeDom);
        // 绘制卡片移动后的虚影
        card2shadow(moveNodeParent, node, this.parentViewApp.kdChartApp.baseCardSize);
        moveNodeParent.appendChild(moveNodeDom);
        if (!this.sortCard) {
            this.sortCard = new SortCard(this.parentViewApp);
        }
    };
    ChartCardApp.prototype.nodeDraging = function (e, node) {
        this.dragNode(e, node);
    };
    ChartCardApp.prototype.nodeDragend = function (e, node) {
        // 删除卡片虚影
        delCard2shadow();
        this.draging = false;
        this.selectedCards = [];
        this.dragNode(e, node, 2);
    };
    ChartCardApp.prototype.nodeMouseMove = function (e, node) {
        if (this.parentViewApp.editStatus) { // 编辑态下
            if (this.cardMenuApp) {
                this.cardMenuApp.showCardMenu(node);
            }
        }
        else { // 查看态下
            if (this.parentViewApp.kdChartApp.hoverMenuRuler(node)) {
                if (this.cardHoverMenuApp) {
                    this.cardHoverMenuApp.showCardMenu(node);
                }
            }
        }
    };
    ChartCardApp.prototype.nodeMouseMouseout = function (e, node) {
        var _a, _b, _c, _d;
        if (this.parentViewApp.editStatus) { // 编辑态下
            if (this.cardMenuApp && ((_b = (_a = e.relatedTarget) === null || _a === void 0 ? void 0 : _a.nodeName) !== null && _b !== void 0 ? _b : "") == "svg") {
                this.cardMenuApp.hiddenMenu();
            }
        }
        else { // 查看态下
            if (this.cardHoverMenuApp && ((_d = (_c = e.relatedTarget) === null || _c === void 0 ? void 0 : _c.nodeName) !== null && _d !== void 0 ? _d : "") == "svg") {
                this.cardHoverMenuApp.hiddenMenu();
            }
        }
    };
    ChartCardApp.prototype.closeCardMenu = function () {
        // 
    };
    //dragStatus  1:draging  2:end
    ChartCardApp.prototype.dragNode = function (e, node, dragStatus) {
        if (dragStatus === void 0) { dragStatus = 1; }
        node.x += e.dx;
        node.y += e.dy;
        var _a = __read(this.getDragNodeInfo(e, node), 3), mouseLayer = _a[0], changeType = _a[1], targetNode = _a[2];
        // 删除上一轮的提示框
        this.sortCard.delSortCard();
        // 删除上一轮的选中
        this.clearSelectCard();
        //拖拽中
        if (dragStatus === 1) {
            // 移动卡片
            this.moveNode(node);
            switch (changeType) {
                case 0:
                    this.parentViewApp.tipsCard.hideTipsGroup();
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                    this.sortCard.showSortCard(node, targetNode, changeType);
                    this.parentViewApp.tipsCard.showTipsCard({
                        x: mouseLayer.x + 18,
                        y: mouseLayer.y + 24
                    }, "变换顺序");
                    break;
                case 5:
                    d3.select(".cardto" + targetNode.id).classed("ghover", true);
                    this.parentViewApp.tipsCard.showTipsCard({
                        x: mouseLayer.x + 18,
                        y: mouseLayer.y + 24
                    }, "移至下级");
                    break;
                case 6:
                    this.parentViewApp.tipsCard.showTipsCard({
                        x: mouseLayer.x + 18,
                        y: mouseLayer.y + 24
                    }, "     移至下级", true);
                    break;
            }
        }
        //拖拽结束
        if (dragStatus === 2) {
            this.parentViewApp.tipsCard.hideTipsGroup();
            switch (changeType) {
                case 0:
                case 6:
                    console.log("不做变更");
                    node.x = node.x0;
                    node.y = node.y0;
                    this.moveNode(node);
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                    console.log("变换顺序");
                    // 变换顺序
                    this.exchangeNode(node, targetNode, changeType);
                    // 操作卡片的公共事件
                    this.operateCardPublic(node, targetNode, changeType);
                    // 重置坐标
                    this.parentViewApp.kdChartApp.chartDataApp.resetCardLoc();
                    // 重绘
                    this.parentViewApp.kdChartApp.resetChartView(changeType);
                    break;
                case 5:
                    console.log("变更上级");
                    // 操作卡片的公共事件
                    this.operateCardPublic(node, targetNode, changeType);
                    // 变更上级
                    this.updateParentNode(node, targetNode);
                    // 重绘（连线会变）
                    this.parentViewApp.kdChartApp.resetChartView(changeType, targetNode);
                    break;
            }
        }
    };
    ChartCardApp.prototype.getDragNodeInfo = function (e, node) {
        var lx = e.sourceEvent.layerX;
        var ly = e.sourceEvent.layerY;
        if (isFF() || isIE()) {
            lx -= this.parentViewApp.rootGroupLoc.x;
            ly -= this.parentViewApp.rootGroupLoc.y;
        }
        else {
            lx += (-this.parentViewApp.rootGroupLoc.x + this.parentViewApp.intialGroupLoc.x);
            ly += (-this.parentViewApp.rootGroupLoc.y + this.parentViewApp.intialGroupLoc.y);
        }
        var mouseLayer = {
            x: lx / this.parentViewApp.rootGroupLoc.k,
            y: ly / this.parentViewApp.rootGroupLoc.k,
        };
        var _a = __read(getMoveCBType(mouseLayer, node, this.parentViewApp.kdChartApp.chartDataApp.chartData, this.parentViewApp.kdChartApp.baseCardSize, this.parentViewApp.kdChartApp.isVertical, this.parentViewApp.kdChartApp.isSameList, this.parentViewApp.kdChartApp.allowChild), 2), changeType = _a[0], targetNode = _a[1];
        return [mouseLayer, changeType, targetNode];
    };
    ChartCardApp.prototype.operateCardPublic = function (node, targetNode, changeType) {
        //  记录操作
        this.parentViewApp.opRecord.push();
        // 用户回调
        this.parentViewApp.kdChartApp.cradCustomOperate({
            node: node,
            targetNode: targetNode,
            changeType: changeType
        });
    };
    ChartCardApp.prototype.moveNode = function (node) {
        //被移动的节点坐标变更
        d3.select(".cardto" + node.id).attr("transform", getNodePaintLoc(node, this.parentViewApp.kdChartApp.baseCardSize));
    };
    ChartCardApp.prototype.exchangeNode = function (moveNode, targetNode, changeType) {
        var i = -1; //挪动的节点
        var j = -1; //挪动节点的目标节点
        moveNode.parent.children.map(function (citem, index) {
            if (citem.id === moveNode.id) {
                i = index;
            }
            if (citem.id === targetNode.id) {
                j = index;
            }
        });
        this.parentViewApp.kdChartApp.treeDataApp.exchangeItem(moveNode.parent.id, i, j, changeType);
        this.parentViewApp.kdChartApp.chartDataApp.exchangeNode(moveNode.parent, i, j, changeType);
    };
    ChartCardApp.prototype.updateParentNode = function (moveNode, targetNode) {
        this.parentViewApp.kdChartApp.treeDataApp.changeParent(moveNode.id, targetNode.id);
        this.parentViewApp.kdChartApp.chartDataApp.initChartData();
    };
    // 卡片点击事件
    ChartCardApp.prototype.clickCard = function (node) {
        if (d3.select(".cardto" + node.id).classed("ghover")) {
            d3.select(".cardto" + node.id).classed("ghover", false);
            delItem(this.selectedCards, node);
        }
        else {
            d3.select(".cardto" + node.id).classed("ghover", true);
            this.selectedCards = pushItem(this.selectedCards, node);
        }
        this.parentViewApp.kdChartApp.cardCustomClick(node);
    };
    ChartCardApp.prototype.clearSelectCard = function () {
        this.selectedCards = [];
        d3.selectAll("g.ghover").classed("ghover", false);
    };
    ChartCardApp.prototype.cardBindEvent = function (cardModel, dom, node) {
        var _this = this;
        dom.on("click", function () {
            cardModel.click && cardModel.click(node, _this.parentViewApp.kdChartApp);
        });
    };
    ChartCardApp.prototype.paintCard = function () {
        var _this = this;
        this.nodeUpdate.nodes().map(function (g) {
            var node = g.__data__;
            if (_this.parentViewApp.isInPaintView(node)) {
                if (g.childNodes.length <= 0 || g.cardModel !== node.cardModel) {
                    g.cardModel = node.cardModel;
                    d3.select(g).selectAll("*").remove();
                    delete _this.toogleGroupMap[node.id];
                    //卡片矩形框
                    g.appendChild(paintRect(node).node());
                    _this.paintCardInfo(node).map(function (svgdom) {
                        g.appendChild(svgdom.node());
                    });
                }
                _this.paintCardToggle(node, g);
            }
            else {
                if (g.childNodes.length > 0) {
                    //清空内容  
                    d3.select(g).selectAll("*").remove();
                    delete _this.toogleGroupMap[node.id];
                }
            }
        });
    };
    ChartCardApp.prototype.updateCardById = function (ids) {
        var _this = this;
        console.log("updateCardById 更新卡片信息");
        this.nodeUpdate.nodes().map(function (g) {
            var node = g.__data__;
            if (ids.indexOf(node.id) > -1) {
                d3.select(g).selectAll("*").remove();
                delete _this.toogleGroupMap[node.id];
                //卡片矩形框
                g.appendChild(paintRect(node).node());
                _this.paintCardInfo(node).map(function (svgdom) {
                    g.appendChild(svgdom.node());
                });
            }
        });
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    ChartCardApp.prototype.updateCardByFlag = function (cb) {
        var _this = this;
        console.log("updateCardById 更新卡片信息");
        this.nodeUpdate.nodes().map(function (g) {
            var node = g.__data__;
            if (cb(node)) {
                d3.select(g).selectAll("*").remove();
                delete _this.toogleGroupMap[node.id];
                //卡片矩形框
                g.appendChild(paintRect(node).node());
                _this.paintCardInfo(node).map(function (svgdom) {
                    g.appendChild(svgdom.node());
                });
            }
        });
    };
    ChartCardApp.prototype.clearCardGroup = function () {
        this.nodeUpdate.nodes().map(function (g) {
            console.log("g", g);
            g.remove();
        });
        this.toogleGroupMap = {};
    };
    // 绘制卡片内容
    // 包括不限：文字、图案、线条、矩形、圆形、字体图标等
    ChartCardApp.prototype.paintCardInfo = function (node) {
        var _this = this;
        var svgdomList = [];
        var cardModels = this.parentViewApp.cardModelMap[node.cardModel] || [];
        cardModels.map(function (cardModel, index) {
            var clipId;
            var imgId;
            var params;
            switch (cardModel.tag) {
                case "text":
                    // eslint-disable-next-line no-case-declarations
                    var _a = __read(paintCardText(cardModel, node), 2), textSvgDom = _a[0], isEllipsis = _a[1];
                    if (textSvgDom) {
                        _this.cardBindEvent(cardModel, textSvgDom, node);
                        svgdomList.push(textSvgDom);
                    }
                    if (textSvgDom && isEllipsis) {
                        _this.setTextTips(textSvgDom, cardModel, node);
                    }
                    break;
                case "img":
                    clipId = "clip" + node.id + "to" + index;
                    imgId = "img" + node.id + "to" + index;
                    params = getImgConfig(cardModel);
                    svgdomList.push(getClipPath(clipId, params));
                    svgdomList.push(paintCardImg(cardModel, clipId, node, imgId, params));
                    break;
                case "rect":
                    svgdomList.push(paintCardRect(cardModel, node));
                    break;
                case "circle":
                    svgdomList.push(paintCardCircle(cardModel, node));
                    break;
                case "path":
                    svgdomList.push(paintCardPath(cardModel));
                    break;
                case "icon":
                    svgdomList.push(paintCardIcon(cardModel, node));
                    break;
            }
        });
        return svgdomList;
    };
    // 文字超长的省略title
    ChartCardApp.prototype.setTextTips = function (dom, cardModel, node) {
        var _this = this;
        if (!this.parentViewApp.textTipsFlag)
            return;
        var textInfo = cardModel.text(node.data).reduce(function (t1, t2) { return t1 + "" + t2; });
        dom.on("mousemove", function () {
            if (_this.parentViewApp.editStatus)
                return;
            _this.parentViewApp.tipsCard.showTipsCard({
                x: node.x,
                y: node.y - node.cardSize.h / 2 + cardModel.h + cardModel.y
            }, textInfo, false, node.cardSize.w);
        }).on("mouseout", function () {
            if (_this.parentViewApp.editStatus)
                return;
            _this.parentViewApp.tipsCard.hideTipsGroup();
        });
    };
    // 绘制折叠按钮
    ChartCardApp.prototype.paintCardToggle = function (node, nodeGroup) {
        var _this = this;
        // 没有子节点不画
        if (!node.data.hasChild) {
            this.removeCardToogle(node.id);
            return;
        }
        // 计算图标的坐标
        var _a = this.parentViewApp.iconConfig, className = _a.className, fontSize = _a.fontSize, toogleMinus = _a.toogleMinus, tooglePlus = _a.tooglePlus;
        var _b = this.parentViewApp.kdChartApp, direction = _b.direction, customParams = _b.customParams;
        var _c = __read(getIconLoc(this.parentViewApp.kdChartApp.direction, node.cardSize, fontSize), 2), rx = _c[0], ry = _c[1];
        var _d = __read(this.parentViewApp.kdChartApp.customOffsetIcon(direction, node, fontSize, rx, ry, customParams), 2), x = _d[0], y = _d[1];
        // 已经有折叠按钮不重画
        if (this.toogleGroupMap[node.id]) {
            // 可能重置坐标
            // console.log("toogle 重置坐标");
            this.setCardToogleLoc(node.id, x, y, fontSize);
            return;
        }
        // 开始绘制折叠按钮
        // console.log("paint toogle icon", node.id);
        var tooglePlusIcon = paintBtnIcon(tooglePlus.unicode, {
            className: className + " op-icon",
            fontSize: fontSize,
            fill: tooglePlus.fill,
            x: x,
            y: y + 1,
            url: tooglePlus.url,
        });
        var toogleMinusIcon = paintBtnIcon(toogleMinus.unicode, {
            className: className + " op-icon",
            fontSize: fontSize,
            fill: toogleMinus.fill,
            x: x,
            y: y + 1,
            url: toogleMinus.url,
        });
        var _e = __read(getCircleMaskLoc(fontSize, x, y), 3), cmr = _e[0], cmx = _e[1], cmy = _e[2];
        var iconMaskCircle = paintCircleMask(cmr, cmx, cmy, "op-icon");
        if (node.children && node.children.length > 0) {
            tooglePlusIcon.attr("style", "display:none;");
        }
        else {
            toogleMinusIcon.attr("style", "display:none;");
        }
        // 展开
        tooglePlusIcon.on("click", function () {
            _this.parentViewApp.kdChartApp.openData(node);
            toogleMinusIcon.attr("style", "");
            tooglePlusIcon.attr("style", "display:none;");
        });
        // 折叠
        toogleMinusIcon.on("click", function () {
            _this.parentViewApp.kdChartApp.foldData(node);
            toogleMinusIcon.attr("style", "display:none;");
            tooglePlusIcon.attr("style", "");
        });
        nodeGroup.appendChild(iconMaskCircle.node());
        nodeGroup.appendChild(tooglePlusIcon.node());
        nodeGroup.appendChild(toogleMinusIcon.node());
        this.toogleGroupMap[node.id] = {
            iconMaskCircle: iconMaskCircle,
            tooglePlusIcon: tooglePlusIcon,
            toogleMinusIcon: toogleMinusIcon
        };
    };
    ChartCardApp.prototype.setCardToogleLoc = function (id, x, y, fontSize) {
        // console.log("重置按钮坐标",id);
        var _a = __read(getCircleMaskLoc(fontSize, x, y), 3), cmx = _a[1], cmy = _a[2];
        this.toogleGroupMap[id].iconMaskCircle.attr("cx", cmx).attr("cy", cmy);
        this.toogleGroupMap[id].tooglePlusIcon.attr("x", x).attr("y", y + (isIE() ? -fontSize : 0));
        this.toogleGroupMap[id].toogleMinusIcon.attr("x", x).attr("y", y + (isIE() ? -fontSize : 0));
    };
    ChartCardApp.prototype.removeCardToogle = function (id) {
        if (this.toogleGroupMap[id]) {
            this.toogleGroupMap[id].iconMaskCircle.remove();
            this.toogleGroupMap[id].tooglePlusIcon.remove();
            this.toogleGroupMap[id].toogleMinusIcon.remove();
            delete this.toogleGroupMap[id];
        }
    };
    return ChartCardApp;
}());

function getInitElbow(rootNode, scale) {
    if (scale === void 0) { scale = 1; }
    var sourceSize = rootNode.cardSize;
    var _a = __read([rootNode.x0 * scale, rootNode.y0 * scale], 2), sourceX = _a[0], sourceY = _a[1];
    return ('M' + sourceX + ',' + (sourceY + sourceSize.h * scale / 2 + 4) + ' V' + sourceY + ' H' + sourceX + ' V' + sourceY);
}
function getElbow(path, baseCardSize, scale) {
    if (scale === void 0) { scale = 1; }
    var _a = __read([path.source.x * scale, path.source.y * scale], 2), sourceX = _a[0], sourceY = _a[1];
    var _b = __read([path.target.x * scale, path.target.y * scale], 2), targetX = _b[0], targetY = _b[1];
    return ('M' + sourceX + ',' + (sourceY + baseCardSize.h * scale / 2) + ' V' + (targetY + sourceY) / 2 + ' H' + targetX + ' V' + (targetY - baseCardSize.h * scale / 2));
}
function getEndElbow(rootNode, scale) {
    if (scale === void 0) { scale = 1; }
    var sourceSize = rootNode.cardSize;
    var _a = __read([rootNode.x * scale, rootNode.y * scale], 2), sourceX = _a[0], sourceY = _a[1];
    return ('M' + sourceX + ',' + (sourceY + sourceSize.h * scale / 2 + 4) + ' V' + sourceY + ' H' + sourceX + ' V' + sourceY);
}

var ChartPathApp = /** @class */ (function () {
    function ChartPathApp(parentViewApp) {
        this.parentViewApp = parentViewApp;
        //连线颜色
        this.pathStyle = {
            stroke: "#ccc"
        };
        this.duration = 500;
        this.initPathGroup();
    }
    ChartPathApp.prototype.initPathGroup = function () {
        this.pathGroup = this.parentViewApp.rootGroup.append("g")
            .attr("class", "pathGroup")
            .attr("fill", "none");
    };
    ChartPathApp.prototype.delPathGroup = function () {
        this.pathGroup.remove();
    };
    ChartPathApp.prototype.initPaint = function (rootNode, repaintPath) {
        if (rootNode === void 0) { rootNode = this.parentViewApp.kdChartApp.chartDataApp.chartData; }
        if (repaintPath === void 0) { repaintPath = false; }
        this.pathList = this.parentViewApp.kdChartApp.chartDataApp.chartData.getLinks();
        this.linkGroup = this.pathGroup.selectAll("path")
            .data(this.pathList, function (d) {
            // console.log("初始化连线group",d.target.id + "_" + d.source.id);
            return d.target.id + "_" + d.source.id;
        });
        this.linkEnter = this.linkGroup.enter().append("path");
        this.setLinkupdate();
        this.linkGroup.exit().remove()
            .attr("d", this.endElbow(rootNode))
            .attr("stroke-opacity", 0);
        repaintPath && (this.paintPath(this.linkEnter, rootNode));
    };
    ChartPathApp.prototype.setLinkupdate = function () {
        var _this = this;
        var transition = this.parentViewApp.rootGroup.transition().duration(this.duration);
        this.linkupdate = this.linkGroup.merge(this.linkEnter).transition(transition)
            .attr("stroke-opacity", 1)
            .attr("d", function (path) { return _this.elbow(path); })
            .attr("stroke", this.pathStyle.stroke);
    };
    ChartPathApp.prototype.resetPaintByLoc = function () {
        this.setLinkupdate();
    };
    ChartPathApp.prototype.paintPath = function (linkEnter, rootNode) {
        linkEnter
            .attr("cursor", "move")
            .attr("stroke", this.pathStyle.stroke)
            .attr("stroke-opacity", 0.1)
            .attr("stroke-width", 1)
            .attr("shape-rendering", "auto")
            .attr("d", this.initElbow(rootNode));
    };
    ChartPathApp.prototype.clearChartPath = function () {
        // 
    };
    ChartPathApp.prototype.initElbow = function (currNode, scale) {
        if (scale === void 0) { scale = 1; }
        return getInitElbow(currNode, scale);
    };
    ChartPathApp.prototype.elbow = function (path) {
        // ===过滤某些线
        var _a = this.parentViewApp.kdChartApp, baseCardSize = _a.baseCardSize, direction = _a.direction, customParams = _a.customParams;
        var res = this.parentViewApp.kdChartApp.getPathScheme(path, baseCardSize, direction, customParams);
        if (res === "") {
            return getElbow(path, baseCardSize);
        }
        return res;
    };
    ChartPathApp.prototype.endElbow = function (rootNode, scale) {
        if (scale === void 0) { scale = 1; }
        return getEndElbow(rootNode, scale);
    };
    return ChartPathApp;
}());

var ChartMainApp = /** @class */ (function () {
    function ChartMainApp(kdChartApp, MainViewParams) {
        this.kdChartApp = kdChartApp;
        this.cardModelMap = MainViewParams.cardModelMap;
        this.menuModels = MainViewParams.menuModels;
        this.hoverMenuModels = MainViewParams.hoverMenuModels;
        this.toogleBtn = MainViewParams.toogleBtn || true; // 是否需要折叠按钮
        this.textTipsFlag = MainViewParams.textTipsFlag || true; // 是否需要文字溢出提示
        this.iconConfig = MainViewParams.iconConfig;
        this.svgBackGround = MainViewParams.svgBackGround || SVG_THEME.background;
        this.editStatus = false;
        this.initStatus();
        this.paintSvgWrapper();
        this.loadSvg();
    }
    // 重绘的时候,会变动的数据
    ChartMainApp.prototype.initStatus = function () {
        this.relativeMaxLoc = {
            x: -Infinity,
            y: -Infinity
        };
        this.svgSize = {
            w: 0,
            h: 0,
            rx: 0,
            ry: 0
        };
        // svgSize值是否更新
        this.svgSizeChange = true;
        // 操作记录
        this.opRecord = [];
        this.currMoveDistance = {
            rx: 0,
            ry: 0,
        };
    };
    ChartMainApp.prototype.paintSvgWrapper = function () {
        var svgWrapperID = this.kdChartApp.chartWrapper.getAttribute("id") + "ChartWrapper";
        if (document.getElementById(svgWrapperID))
            document.getElementById(svgWrapperID).parentNode.removeChild(document.getElementById(svgWrapperID));
        this.svgWrapper = paintWrapper(svgWrapperID, this.kdChartApp.chartWrapperSize);
        this.kdChartApp.chartWrapper.appendChild(this.svgWrapper.node());
    };
    ChartMainApp.prototype.loadSvg = function () {
        var _this = this;
        this.svgWrapper.html(null);
        this.svgWrapper.append(function () { return _this.createSvg(); });
    };
    ChartMainApp.prototype.createSvg = function () {
        this.svg = paintSvg(this.svgBackGround);
        this.bindEvent2svg();
        this.rootGroup = this.svg.append("g");
        this.initPaintChart();
        this.paintTipsGroup();
        return this.svg.node();
    };
    // 计算画布大小，计算画布坐标原点
    ChartMainApp.prototype.brforePaintChart = function () {
        // 计算svgSize svgSizeChange
        this.computedMixLoc();
        if (this.svgSizeChange) {
            // 绘制svg
            this.setSvgParams();
            // 计算rootGroup
            this.initRootGroupLoc(this.kdChartApp.chartDataApp.chartData);
            // 设置rootGroup
            this.moveRootGroup();
        }
    };
    ChartMainApp.prototype.initPaintChart = function () {
        this.brforePaintChart();
        this.chartPathApp = new ChartPathApp(this);
        this.chartPathApp.initPaint(this.kdChartApp.chartDataApp.chartData, true);
        this.chartCardApp = new ChartCardApp(this);
        this.chartCardApp.initPaint(this.kdChartApp.chartDataApp.chartData);
        // if (this.kdChartApp.direction == 2 || this.kdChartApp.direction == 4){
        //     this.moveSvgByDir()
        // }
    };
    ChartMainApp.prototype.updatePaintChart = function (rootNode, repaintInfo) {
        if (rootNode === void 0) { rootNode = this.kdChartApp.chartDataApp.chartData; }
        if (repaintInfo === void 0) { repaintInfo = false; }
        this.brforePaintChart();
        this.chartPathApp.initPaint(rootNode, repaintInfo);
        this.chartCardApp.initPaint(rootNode, repaintInfo);
    };
    ChartMainApp.prototype.cardOpRepaint = function (changeType, rootNode) {
        if (rootNode === void 0) { rootNode = this.kdChartApp.chartDataApp.chartData; }
        switch (changeType) {
            case 1:
            case 2:
            case 3:
            case 4:
                /**
                 * 变换顺序
                 * 1.不会重绘卡片内容
                 * 2.影响画布的宽高
                 */
                this.brforePaintChart();
                this.chartPathApp.resetPaintByLoc();
                this.chartCardApp.resetPaintByLoc();
                break;
            case 5:
                /**
                 * 变更上级
                 * 1.改变数据结构
                 * 2.坐标连线重绘
                 * 3.影响折叠按钮
                 */
                this.updatePaintChart(rootNode, true);
                break;
        }
    };
    ChartMainApp.prototype.bindEvent2svg = function () {
        var _this = this;
        this.svg.call(d3.zoom()
            .on("start", function (e) {
            // console.log("start", e.sourceEvent.type);
            _this.svgClient = {
                x: e.sourceEvent.clientX,
                y: e.sourceEvent.clientY
            };
        })
            .on("zoom", function (e) {
            _this.svgZoomHandle(e);
        })
            .on("end", function (e) {
            // console.log("end");
            var deltaY = e.sourceEvent.deltaY || 0;
            if (deltaY != 0) {
                _this.currMoveDistance = {
                    rx: 0,
                    ry: 0,
                };
                _this.chartCardApp.paintCard();
            }
        })
            .filter(function (e) { return excludeClassName(e, ["op-icon"]); })).on("click.zoom", function (e) {
            _this.svgClickHadnle(e);
        });
    };
    ChartMainApp.prototype.svgZoomHandle = function (e) {
        var k;
        var rx;
        var ry;
        switch (e.sourceEvent.type) {
            case "wheel":
                k = this.rootGroupLoc.k + (e.sourceEvent.deltaY > 0 ? -1 : 1) * WHEEL_STEP;
                k = Math.min(WHEEL_MAX, k);
                k = Math.max(WHEEL_MIN, k);
                this.operatorRootGroup({ k: k });
                break;
            case "mousemove":
                rx = (e.sourceEvent.clientX - this.svgClient.x) / window.devicePixelRatio;
                ry = (e.sourceEvent.clientY - this.svgClient.y) / window.devicePixelRatio;
                this.operatorRootGroup({ rx: rx, ry: ry });
                this.currMoveDistance.rx += rx;
                this.currMoveDistance.ry += ry;
                this.svgClient = {
                    x: e.sourceEvent.clientX,
                    y: e.sourceEvent.clientY
                };
                break;
        }
    };
    ChartMainApp.prototype.svgClickHadnle = function (e) {
        if (e.target.nodeName === "svg") {
            if (this.editStatus) {
                this.chartCardApp.clearSelectCard();
                this.kdChartApp.customSvgClick();
            }
        }
    };
    ChartMainApp.prototype.paintTipsGroup = function () {
        this.tipsCard = new TipsCard(this);
    };
    ChartMainApp.prototype.operatorRootGroup = function (_a) {
        var _b = _a === void 0 ? { rx: 0, ry: 0, k: this.rootGroupLoc.k } : _a, _c = _b.rx, rx = _c === void 0 ? 0 : _c, _d = _b.ry, ry = _d === void 0 ? 0 : _d, _e = _b.k, k = _e === void 0 ? this.rootGroupLoc.k : _e;
        this.moveRootGroup({ rx: rx, ry: ry, k: k });
        this.kdChartApp.preViewApp && this.kdChartApp.preViewApp.resetGroupLoc({ rx: rx, ry: ry, k: k });
        if (Math.abs(this.currMoveDistance.rx) >= (VIEW_OFFSET - this.kdChartApp.baseCardSize.w) ||
            Math.abs(this.currMoveDistance.ry) >= (VIEW_OFFSET - this.kdChartApp.baseCardSize.h)) {
            this.currMoveDistance = {
                rx: 0,
                ry: 0,
            };
            this.chartCardApp.paintCard();
        }
    };
    // 左右方向，调整图的位置
    ChartMainApp.prototype.moveSvgByDir = function () {
        var loc = {
            rx: 0,
            ry: -this.kdChartApp.chartDataApp.chartData.y + this.kdChartApp.chartWrapperSize.h / 2,
            k: 1
        };
        this.moveRootGroup(loc);
        this.kdChartApp.preViewApp && this.kdChartApp.preViewApp.resetGroupLoc(loc);
        this.chartCardApp.paintCard();
    };
    // 计算svgSize,判断svgSize变化
    // 计算最大,最小值
    ChartMainApp.prototype.computedMixLoc = function () {
        var _this = this;
        this.maxLoc = {
            x: -Infinity,
            y: -Infinity
        };
        this.minLoc = {
            x: Infinity,
            y: Infinity
        };
        this.kdChartApp.chartDataApp.chartData.getNodes().forEach(function (node) {
            _this.minLoc.x = Math.min(node.x, _this.minLoc.x);
            _this.minLoc.y = Math.min(node.y, _this.minLoc.y);
            _this.maxLoc.x = Math.max(node.x, _this.maxLoc.x);
            _this.maxLoc.y = Math.max(node.y, _this.maxLoc.y);
        });
        this.relativeMaxLoc.x = Math.max(this.maxLoc.x, Math.abs(this.minLoc.x));
        this.relativeMaxLoc.y = Math.max(this.maxLoc.y, Math.abs(this.minLoc.y));
        //计算svg所需的宽度\高度
        var w = Math.max(this.relativeMaxLoc.x * 2 + this.kdChartApp.baseCardSize.w * 2, this.kdChartApp.chartWrapperSize.w);
        var h = Math.max(this.relativeMaxLoc.y + this.kdChartApp.baseCardSize.h * 2, this.kdChartApp.chartWrapperSize.h);
        this.svgSizeChange = (w !== this.svgSize.w);
        //svg的宽高和位置
        this.svgSize = {
            w: w,
            h: h,
            rx: (this.kdChartApp.chartWrapperSize.w - w) / 2,
            ry: 0
        };
    };
    ChartMainApp.prototype.moveRootGroup = function (moveLoc) {
        if (moveLoc === void 0) { moveLoc = { rx: 0, ry: 0, k: this.rootGroupLoc.k }; }
        this.rootGroupLoc.x += moveLoc.rx;
        this.rootGroupLoc.y += moveLoc.ry;
        this.rootGroupLoc.k = moveLoc.k || this.rootGroupLoc.k;
        this.rootGroup.attr("transform", "translate(" + this.rootGroupLoc.x + "," + this.rootGroupLoc.y + ") scale(" + this.rootGroupLoc.k + ")");
    };
    // 初始化rootGroupLoc
    // moveNodeOffset：折叠等操作前，group已经移动的距离
    ChartMainApp.prototype.initRootGroupLoc = function (chartData) {
        var _a, _b;
        var moveNodeOffset = { rx: 0, ry: 0 };
        if (this.rootGroupLoc && this.intialGroupLoc) {
            moveNodeOffset = {
                rx: this.rootGroupLoc.x - this.intialGroupLoc.x,
                ry: this.rootGroupLoc.y - this.intialGroupLoc.y
            };
        }
        //计算group缩放倍数
        var k = (_b = (_a = this.rootGroupLoc) === null || _a === void 0 ? void 0 : _a.k) !== null && _b !== void 0 ? _b : 1;
        switch (this.kdChartApp.direction) {
            case 1:
                //group偏移坐标和缩放倍数
                //chartData.x 水平始终居中
                this.rootGroupLoc = {
                    x: this.svgSize.w / 2 - chartData.x + moveNodeOffset.rx,
                    y: moveNodeOffset.ry,
                    k: k,
                };
                //保留groupLoc初始数据
                //chartData.x 水平始终居中
                this.intialGroupLoc = {
                    x: this.svgSize.w / 2 - chartData.x,
                    y: 0,
                    k: k,
                };
                break;
            case 2:
                this.rootGroupLoc = {
                    x: this.svgSize.w / 2 + moveNodeOffset.rx,
                    y: moveNodeOffset.ry,
                    k: k,
                };
                this.intialGroupLoc = {
                    x: this.svgSize.w / 2,
                    y: 0,
                    k: k,
                };
                break;
            case 3:
                this.rootGroupLoc = {
                    x: this.svgSize.w / 2 - chartData.x + moveNodeOffset.rx,
                    y: moveNodeOffset.ry,
                    k: k,
                };
                this.intialGroupLoc = {
                    x: this.svgSize.w / 2 - chartData.x,
                    y: 0,
                    k: k,
                };
                break;
            case 4:
                this.rootGroupLoc = {
                    x: this.svgSize.w / 2 + moveNodeOffset.rx,
                    y: moveNodeOffset.ry,
                    k: k,
                };
                this.intialGroupLoc = {
                    x: this.svgSize.w / 2,
                    y: 0,
                    k: k,
                };
                break;
        }
    };
    ChartMainApp.prototype.setSvgParams = function () {
        this.svg
            .style("width", this.svgSize.w + "px")
            .style("height", this.svgSize.h + "px")
            .style("transform", "translate(".concat(this.svgSize.rx, "px,").concat(this.svgSize.ry, "px)"));
    };
    ChartMainApp.prototype.isInPaintView = function (node) {
        if (!node)
            return false;
        var svgWrapperSize = this.kdChartApp.chartWrapperSize;
        var groupPot = {
            x: this.svgSize.w / 2,
            y: 0
        };
        var isin = true;
        var minX = -svgWrapperSize.w * 0.5 - VIEW_OFFSET;
        var maxX = svgWrapperSize.w * 0.5 + VIEW_OFFSET;
        var minY = -svgWrapperSize.w * 0 - VIEW_OFFSET;
        var maxY = svgWrapperSize.w * 1 + VIEW_OFFSET;
        // (this.groupLoc.x - groupPot.x)  group横向偏移距离
        // flagX 该卡片横向偏移后的坐标
        var flagX = node.x * this.rootGroupLoc.k + (this.rootGroupLoc.x - groupPot.x);
        // (this.groupLoc.y - groupPot.y)  group纵向偏移距离
        // flagY该卡片纵向偏移后的坐标
        var flagY = node.y * this.rootGroupLoc.k + (this.rootGroupLoc.y - groupPot.y);
        // 偏移后的相对坐标，在可加载区域内，则渲染
        isin = flagX > minX && flagX < maxX && flagY > minY && flagY < maxY;
        return isin;
    };
    return ChartMainApp;
}());

var ChartPreApp = /** @class */ (function () {
    function ChartPreApp(kdChartApp, params) {
        this.kdChartApp = kdChartApp;
        this.previewSvgSize = params.previewSvgSize;
        this.preViewCardModelMap = params.preViewCardModelMap;
        this.paintPreView();
    }
    ChartPreApp.prototype.paintPreView = function () {
        this.initParams();
        this.initDom();
        this.initChart();
        // 移动视图框，保证顶点在视图范围内的中心位置
        // if (this.kdChartApp.direction == 2 || this.kdChartApp.direction == 4) {
        //     this.dragSlide(0, (this.kdChartApp.chartDataApp.chartData.y -
        //         this.kdChartApp.chartDataApp.chartData.cardSize.h / 2) *
        //         this.previewScale - this.slideRectSize.h / 2)
        // }
    };
    ChartPreApp.prototype.initParams = function () {
        // 缩略图的缩小比例
        this.previewScale = Math.min(this.previewSvgSize.w / this.kdChartApp.mainViewApp.svgSize.w, this.previewSvgSize.h / this.kdChartApp.mainViewApp.svgSize.h);
        //区域框：主图显示的部分
        this.slideRectSize = {
            w: this.kdChartApp.chartWrapperSize.w * this.previewScale,
            h: this.kdChartApp.chartWrapperSize.h * this.previewScale
        };
        //区域框坐标
        this.slideGroupLoc = {
            x: this.previewSvgSize.w / 2,
            y: 0,
            k: 1
        };
        this.slideRectLoc = {
            x: -this.slideRectSize.w / 2,
            y: 0
        };
    };
    ChartPreApp.prototype.initDom = function () {
        d3.selectAll(".preview_wrapper").remove();
        this.previewWrapper = d3.create("div")
            .attr("class", "preview_wrapper")
            .style("width", "".concat(this.previewSvgSize.w, "px"))
            .style("height", "".concat(this.previewSvgSize.h, "px"))
            .style("box-sizing", "border-box")
            .style("border", "1px solid rgba(238,238,238,1)")
            .style("position", "absolute")
            .style("top", "32px")
            .style("right", "16px")
            .style("overflow", "hidden")
            .style("z-index", "1");
        this.kdChartApp.chartWrapper.appendChild(this.previewWrapper.node());
    };
    ChartPreApp.prototype.initChart = function () {
        var _this = this;
        this.previewWrapper.html(null);
        this.previewWrapper.append(function () { return _this.initSvg(); });
    };
    ChartPreApp.prototype.initSvg = function () {
        var _this = this;
        this.svg = d3.create("svg")
            .style("width", "".concat(this.previewSvgSize.w, "px"))
            .style("height", "".concat(this.previewSvgSize.h, "px"))
            .style("background", "#f5f5f5")
            .style("user-select", "none")
            .on("click", function (e) {
            _this.setSlideLoc(e);
        });
        this.group = this.svg.append("g").attr("transform", "translate(".concat(this.previewSvgSize.w / 2, ",0) scale(1)"));
        this.linkGroup = this.group.append("g").attr("fill", "none");
        this.nodeGroup = this.group.append("g").attr("cursor", "pointer").attr("pointer-events", "visible");
        this.paintChart();
        this.paintSlide();
        return this.svg.node();
    };
    ChartPreApp.prototype.paintChart = function () {
        this.paintPath();
        this.paintCard(this.kdChartApp.chartDataApp.chartData);
    };
    ChartPreApp.prototype.paintPath = function () {
        var _this = this;
        this.links = this.kdChartApp.chartDataApp.chartData.getLinks();
        var transition = this.group.transition().duration(0);
        var linkGroup = this.linkGroup.selectAll("path")
            .data(this.links, function (d) { return d["target"]["id"]; });
        var linkEnter = linkGroup.enter().append("path")
            .attr("stroke", "#d9d9d9")
            .attr("stroke-opacity", 1)
            .attr("stroke-width", 1)
            .attr("shape-rendering", "auto");
        this.linkupdate = linkGroup.merge(linkEnter)
            .transition(transition)
            .attr("stroke-opacity", 1)
            .attr("stroke-width", 1)
            .attr("d", function (d) { return _this.elbow(d, _this.previewScale); });
        linkGroup.exit().transition(transition).remove()
            .attr("stroke-opacity", 0.1);
    };
    ChartPreApp.prototype.paintCard = function (currNode) {
        var _this = this;
        var baseCardSize = this.kdChartApp.baseCardSize;
        this.nodes = this.kdChartApp.chartDataApp.chartData.getNodes().reverse();
        var transition = this.group.transition().duration(0);
        var nodeGroup = this.nodeGroup.selectAll("g")
            .data(this.nodes, function (d) { return d["id"]; });
        var nodeEnter = nodeGroup.enter().append("g")
            .attr("transform", getNodePaintLoc(currNode, baseCardSize, this.previewScale));
        this.nodeUpdate = nodeGroup.merge(nodeEnter);
        this.nodeUpdate.transition(transition)
            .attr("transform", function (node) { return getNodePaintLoc(node, baseCardSize, _this.previewScale); })
            .attr("fill-opacity", 1)
            .attr("stroke-opacity", 1);
        this.nodeUpdate.append("rect")
            .attr("width", function (node) { return node.cardSize.w * _this.previewScale; })
            .attr("height", function (node) { return node.cardSize.h * _this.previewScale; })
            .attr("fill", "#fff")
            .attr("stroke", "#d9d9d9")
            .attr("stroke-opacity", 1)
            .attr("stroke-width", 0.5);
        this.nodeUpdate.append("rect")
            .attr("x", this.previewScale)
            .attr("width", function (node) { return (node.cardSize.w - 2) * _this.previewScale; })
            .attr("height", 2 * this.previewScale)
            .attr("fill", function (node) { return _this.preViewCardModelMap[node.cardModel]; })
            .attr("stroke", function (node) { return _this.preViewCardModelMap[node.cardModel]; });
        // this.paintInfo()
        nodeGroup.exit().transition(transition).remove()
            .attr("transform", getNodePaintLoc(currNode, baseCardSize, this.previewScale))
            .attr("stroke-opacity", 0)
            .attr("fill-opacity", 0);
    };
    ChartPreApp.prototype.paintSlide = function () {
        var _this = this;
        this.slideGroup = this.svg.append("g")
            .attr("transform", "translate(".concat(this.slideGroupLoc.x, ",").concat(this.slideGroupLoc.y, ") scale(").concat(this.slideGroupLoc.k, ")"))
            .call(d3.drag()
            .on("drag", function (e) {
            _this.dragSlide(e.dx, e.dy);
        }));
        this.slideGroup.append("rect")
            .attr("width", Math.max(this.slideRectSize.w - 2, 1))
            .attr("height", this.slideRectSize.h)
            .attr("fill-opacity", 0)
            .attr("stroke", "#5582F3")
            .attr("cursor", "pointer")
            .attr("stroke-width", 1)
            .attr("transform", "translate(".concat(this.slideRectLoc.x, ",").concat(this.slideRectLoc.y, ")"));
    };
    ChartPreApp.prototype.setSlideLoc = function (e) {
        var newX = (e.layerX - this.previewSvgSize.w / 2) - this.slideRectSize.w / 2;
        var newY = e.layerY - this.slideRectSize.h / 2;
        var rx = newX - this.slideRectLoc.x;
        var ry = newY - this.slideRectLoc.y;
        this.dragSlide(rx, ry);
    };
    ChartPreApp.prototype.dragSlide = function (dx, dy) {
        this.moveSlideGroup({
            rx: dx,
            ry: dy
        });
        this.kdChartApp.mainViewApp.moveRootGroup({
            rx: -dx / this.previewScale,
            ry: -dy / this.previewScale,
            k: this.kdChartApp.mainViewApp.rootGroupLoc.k
        });
        this.kdChartApp.mainViewApp.chartCardApp.paintCard();
    };
    ChartPreApp.prototype.moveSlideGroup = function (moveLoc) {
        this.slideRectLoc.x += moveLoc.rx;
        this.slideRectLoc.y += moveLoc.ry;
        this.slideGroup.select("rect").attr("transform", "translate(".concat(this.slideRectLoc.x, ",").concat(this.slideRectLoc.y, ")"));
    };
    ChartPreApp.prototype.scaleSlideGroup = function (k) {
        this.slideGroupLoc.k = 1 / k;
        this.slideGroup
            .attr("transform", "translate(".concat(this.slideGroupLoc.x, ",").concat(this.slideGroupLoc.y, ") scale(").concat(this.slideGroupLoc.k, ")"));
        this.slideGroup.select("rect")
            .attr("stroke-width", k);
    };
    ChartPreApp.prototype.resetGroupLoc = function (loc) {
        this.moveSlideGroup({
            rx: -loc.rx * this.previewScale,
            ry: -loc.ry * this.previewScale,
        });
        this.scaleSlideGroup(loc.k);
    };
    ChartPreApp.prototype.elbow = function (path, previewScale) {
        // 过滤某些线
        if (!this.kdChartApp.preViewPathFilt(path))
            return;
        var _a = this.kdChartApp, baseCardSize = _a.baseCardSize, direction = _a.direction, customParams = _a.customParams;
        var res = this.kdChartApp.getPathScheme(path, baseCardSize, direction, customParams, previewScale);
        if (res === "") {
            return getElbow(path, baseCardSize);
        }
        return res;
    };
    return ChartPreApp;
}());

var TreeDataApp = /** @class */ (function () {
    function TreeDataApp(kdChartApp, treeData) {
        this.kdChartApp = kdChartApp;
        this.treeData = treeData;
        this.treeDataMap = {};
        this.computedTreeHeight();
        this.initFormData(this.treeData, null);
    }
    // 设置hasParent parent hasChild [preChild] _children属性
    // preChild 预设有下级
    // 增删数据影响hasChild
    TreeDataApp.prototype.initFormData = function (treeData, parent) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var _this = this;
        function eachObj(treeItem, parent) {
            treeItem.hasParent = !!parent;
            treeItem.parent = parent;
            treeItem.hasChild = !!treeItem.children && treeItem.children.length > 0;
            treeItem._children = treeItem.children;
            treeItem.preChild = _this.kdChartApp.setPreChild(treeItem);
            _this.kdChartApp.customTreeItemAttr(treeItem);
            _this.treeDataMap[treeItem.id + ''] = treeItem;
            if (treeItem.hasChild) {
                treeItem.children.map(function (childTreeItem) {
                    eachObj(childTreeItem, treeItem);
                });
            }
        }
        eachObj(treeData, parent);
    };
    TreeDataApp.prototype.computedTreeHeight = function () {
        function eachObj(treeItem, level) {
            treeItem.level = level++;
            if (treeItem.children && treeItem.children.length > 0) {
                var height_1 = 0;
                treeItem.children.map(function (childTreeItem) {
                    height_1 = Math.max(height_1, eachObj(childTreeItem, level));
                });
                treeItem.height = height_1 + 1;
            }
            else {
                treeItem.height = 0;
            }
            return treeItem.height;
        }
        eachObj(this.treeData, 0);
    };
    TreeDataApp.prototype.exchangeItem = function (pid, i, j, changeType) {
        searchNodeByID(this.treeData, pid, function (parent) {
            exchangeItemSort(parent.children, i, j, changeType);
        });
    };
    TreeDataApp.prototype.changeParent = function (cid, pid) {
        var _a;
        var pnode = null;
        var cnode = null;
        // 1.找到cnode pnode
        each([this.treeData]);
        function each(list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].id === cid) {
                    cnode = list[i];
                }
                if (list[i].id === pid) {
                    pnode = list[i];
                }
                if (pnode === null || cnode === null) {
                    if (list[i].children && list[i].children.length > 0) {
                        each(list[i].children);
                    }
                }
            }
        }
        //处理旧parent
        var cnodeIndex = cnode.parent.children.indexOf(cnode);
        cnode.parent.children.splice(cnodeIndex, 1);
        if (cnode.parent.children.length === 0) {
            cnode.parent.children = undefined;
            cnode.parent.hasChild = false;
        }
        cnode.parent._children = cnode.parent.children;
        //处理moveNode
        cnode.parent = pnode;
        //处理新parent
        pnode.children = (_a = (pnode.children || pnode._children)) !== null && _a !== void 0 ? _a : [];
        pnode.children.push(cnode);
        pnode._children = pnode.children;
        pnode.hasChild = true;
        this.computedTreeHeight();
    };
    TreeDataApp.prototype.foldData = function (node) {
        searchNodeByID(this.treeData, node.id, function (item) {
            item._children = item.children;
            item.children = null;
        });
    };
    TreeDataApp.prototype.openData = function (node) {
        searchNodeByID(this.treeData, node.id, function (item) {
            item.children = item._children;
        });
    };
    // 新增卡片
    TreeDataApp.prototype.cardMenuAdd = function (newTreeItem, pid) {
        var _a;
        this.treeDataMap[pid].children = (_a = this.treeDataMap[pid].children) !== null && _a !== void 0 ? _a : [];
        this.treeDataMap[pid].children.push(newTreeItem);
        // 重新计算节点高度
        this.computedTreeHeight();
        // 设置hasParent parent hasChild [preChild] _children属性
        this.initFormData(this.treeDataMap[pid], this.treeDataMap[pid].parent);
    };
    TreeDataApp.prototype.cardMenuEdit = function (node, newInfo) {
        var _this_1 = this;
        Object.keys(newInfo).map(function (key) {
            _this_1.treeDataMap[node.id][key] = newInfo[key];
        });
    };
    TreeDataApp.prototype.cardMenuDel = function (node) {
        if (node.parent) {
            delItem(this.treeDataMap[node.parent.id].children, node);
        }
        else {
            this.treeData = null;
        }
    };
    TreeDataApp.prototype.setItemsAttr = function (ids, key, val) {
        var _this_1 = this;
        ids.map(function (id) {
            if (key) {
                _this_1.treeDataMap[id][key] = val;
            }
        });
    };
    return TreeDataApp;
}());

var KdChart = /** @class */ (function () {
    function KdChart(params) {
        if (!params.chartWrapper) {
            console.error("容器不可缺少");
        }
        else {
            this.direction = params.direction || DIRECTION;
            this.baseCardSize = params.baseCardSize || BASE_CARD_SIZE;
            this.initLevel = params.initLevel || INIT_LEVEL;
            this.customParams = params.customParams || {};
            this.chartWrapper = params.chartWrapper;
            this.chartWrapperStyle();
        }
    }
    KdChart.prototype.chartWrapperStyle = function () {
        this.chartWrapper.style.position = "relative";
        this.chartWrapper.style.boxSizing = "border-box";
        this.chartWrapperSize = {
            w: this.chartWrapper.offsetWidth,
            h: this.chartWrapper.offsetHeight
        };
    };
    KdChart.prototype.initData = function (treeData) {
        if (!treeData) {
            console.error("缺少树图数据");
        }
        else {
            // 初始化treeData
            this.treeDataApp = new TreeDataApp(this, treeData);
            // 初始化chartData
            this.chartDataApp = new ChartDataApp(this);
        }
    };
    KdChart.prototype.initMainView = function (MainViewParams) {
        if (!MainViewParams.cardModelMap) {
            console.error("缺少卡片模板数据");
        }
        if (!this.chartDataApp.chartData) {
            console.error("缺少卡片树图数据");
        }
        else {
            //实例化主图
            this.mainViewApp = new ChartMainApp(this, MainViewParams);
        }
    };
    KdChart.prototype.initPreView = function (params) {
        if (!this.mainViewApp) {
            console.error("缺少主视图");
        }
        else {
            this.preViewApp = new ChartPreApp(this, params);
        }
    };
    KdChart.prototype.resetChartView = function (changeType, rootNode) {
        if (rootNode === void 0) { rootNode = this.chartDataApp.chartData; }
        this.mainViewApp.cardOpRepaint(changeType, rootNode);
        if (this.preViewApp) {
            this.preViewApp.paintPreView();
        }
    };
    KdChart.prototype.resetCoordinate = function () {
        this.chartDataApp.initChartData();
        this.mainViewApp.updatePaintChart(this.chartDataApp.chartData, true);
        this.mainViewApp.chartCardApp.clearSelectCard();
        if (this.preViewApp) {
            this.preViewApp.paintPreView();
        }
    };
    KdChart.prototype.foldData = function (node) {
        this.treeDataApp.foldData(node);
        this.chartDataApp.initChartData();
        this.mainViewApp.updatePaintChart(this.chartDataApp.chartDataMap[node.id]);
        if (this.preViewApp) {
            this.preViewApp.paintPreView();
        }
    };
    KdChart.prototype.openData = function (node) {
        this.treeDataApp.openData(node);
        this.chartDataApp.initChartData();
        this.mainViewApp.updatePaintChart(this.chartDataApp.chartDataMap[node.id], true);
        if (this.preViewApp) {
            this.preViewApp.paintPreView();
        }
    };
    KdChart.prototype.setEditStatus = function (flag) {
        if (flag === void 0) { flag = false; }
        this.mainViewApp.editStatus = flag;
    };
    // ========================卡片新增==============================
    // 新增卡片，用户钩子
    KdChart.prototype.cardMenuAddCustom = function (pnode) {
        this.cardMenuAdd({
            id: (pnode.id + "").substring(0, 16) + "_" + (new Date().getTime())
        }, pnode.id);
    };
    // 新增卡片
    KdChart.prototype.cardMenuAdd = function (newTreeItem, pid) {
        this.treeDataApp.cardMenuAdd(newTreeItem, pid);
        this.chartDataApp.initChartData();
        this.mainViewApp.updatePaintChart(this.chartDataApp.chartDataMap[pid], true);
        this.mainViewApp.chartCardApp.cardMenuApp.hiddenMenu();
    };
    // ========================卡片删除==============================
    // 删除卡片，用户钩子
    KdChart.prototype.cardMenuDelCustom = function (node) {
        this.cardMenuDel(node);
    };
    // 删除卡片（动画待优化）
    KdChart.prototype.cardMenuDel = function (node) {
        var delNode = __assign({}, this.chartDataApp.chartDataMap[node.id]);
        this.treeDataApp.cardMenuDel(node);
        this.chartDataApp.initChartData();
        if (this.treeDataApp.treeData) {
            this.mainViewApp.updatePaintChart(delNode);
            this.mainViewApp.chartCardApp.updateCardById([node.parent.id]);
        }
        else {
            this.mainViewApp.chartCardApp.delCardGroup();
            this.mainViewApp.chartPathApp.delPathGroup();
        }
        this.mainViewApp.chartCardApp.cardMenuApp.hiddenMenu();
    };
    // ========================卡片编辑==============================
    // 编辑卡片，用户钩子
    KdChart.prototype.cardMenuEditCustom = function (node) {
        console.warn("请调用cardMenuEdit方法，传入新的属性", node);
    };
    // 编辑卡片
    KdChart.prototype.cardMenuEdit = function (node, newInfo) {
        this.treeDataApp.cardMenuEdit(node, newInfo);
        this.chartDataApp.cardMenuEdit(node, newInfo);
        this.mainViewApp.chartCardApp.updateCardById([node.id]);
        this.mainViewApp.chartCardApp.cardMenuApp.hiddenMenu();
    };
    // =======================给treedata添加属性======================
    KdChart.prototype.setTreeDataAttr = function (ids, key, val) {
        this.treeDataApp.setItemsAttr(ids, key, val);
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    KdChart.prototype.eachTreeData = function (cb) {
        eachObj(this.treeDataApp.treeData, cb);
    };
    // =======================获取一些数据============================
    KdChart.prototype.getSelectCard = function () {
        return this.mainViewApp.chartCardApp.selectedCards || [];
    };
    KdChart.prototype.upCustomParams = function (key, val) {
        this.customParams[key] = val;
    };
    // ------用户可重写的方法---------------------------
    // 预设child（暂未使用）
    KdChart.prototype.setPreChild = function (treeItem) { return false; };
    // 用户自定义补充属性
    KdChart.prototype.customTreeItemAttr = function (treeItem) {
        // 
    };
    // hoverMenu规则
    KdChart.prototype.hoverMenuRuler = function (node) { return true; };
    // 缩略图连线过滤规则（优化性能）
    KdChart.prototype.preViewPathFilt = function (path) { return true; };
    // 计算坐标
    KdChart.prototype.computedLocMap = function (treeData, baseCardSize, chartWrapperSize, direction, customParams) {
        return computedCoordinate(treeData, baseCardSize);
    };
    KdChart.prototype.customOffsetIcon = function (direction, node, fontSize, rx, ry, customParams) {
        return [rx, ry];
    };
    // 用户自定义补充属性
    KdChart.prototype.customChartItemAttr = function (chartItem, customParams) {
        // 
    };
    // 用户自定义连线
    KdChart.prototype.getPathScheme = function (path, baseCardSize, direction, customParams, scale) {
        return "";
    };
    // 卡片点击用户钩子
    KdChart.prototype.cardCustomClick = function (arg1) {
        // 
    };
    KdChart.prototype.customSvgClick = function () {
        // 
    };
    // 卡片操作用户钩子
    KdChart.prototype.cradCustomOperate = function (params) {
        // 
    };
    // 卡片是否需要菜单
    KdChart.prototype.flagMenu = function (arg1) {
        return {
            flag: true,
            forbid: []
        };
    };
    KdChart.prototype.isVertical = function (node) { return false; };
    KdChart.prototype.allowChild = function (node) { return true; };
    KdChart.prototype.isSameList = function (node1, node2) { return true; };
    // 用户事件转发
    KdChart.prototype.routeEvent = function (arg) {
        // 
    };
    return KdChart;
}());

export { KdChart as default };
